{
  "AC": {
    "en": "Ascension Island",
    "tr": "Ascension Adası",
    "es": "Isla de la Ascensión",
    "pt-BR": "Ilha de Ascensão",
    "fr": "Île de l’Ascension",
    "de": "Ascension",
    "zh-Hans": "阿森松岛",
    "hi": "असेंशन द्वीप",
    "ja": "アセンション島",
    "ru": "о-в Вознесения",
    "id": "Pulau Ascension",
    "bn": "অ্যাসেনশন দ্বীপপুঞ্জ"
  },
  "AD": {
    "en": "Andorra",
    "tr": "Andorra",
    "es": "Andorra",
    "pt-BR": "Andorra",
    "fr": "Andorre",
    "de": "Andorra",
    "zh-Hans": "安道尔",
    "hi": "एंडोरा",
    "ja": "アンドラ",
    "ru": "Андорра",
    "id": "Andorra",
    "bn": "আন্ডোরা"
  },
  "AE": {
    "en": "United Arab Emirates",
    "tr": "Birleşik Arap Emirlikleri",
    "es": "Emiratos Árabes Unidos",
    "pt-BR": "Emirados Árabes Unidos",
    "fr": "Émirats arabes unis",
    "de": "Vereinigte Arabische Emirate",
    "zh-Hans": "阿拉伯联合酋长国",
    "hi": "संयुक्त अरब अमीरात",
    "ja": "アラブ首長国連邦",
    "ru": "ОАЭ",
    "id": "Uni Emirat Arab",
    "bn": "সংযুক্ত আরব আমিরাত"
  },
  "AF": {
    "en": "Afghanistan",
    "tr": "Afganistan",
    "es": "Afganistán",
    "pt-BR": "Afeganistão",
    "fr": "Afghanistan",
    "de": "Afghanistan",
    "zh-Hans": "阿富汗",
    "hi": "अफ़गानिस्तान",
    "ja": "アフガニスタン",
    "ru": "Афганистан",
    "id": "Afganistan",
    "bn": "আফগানিস্তান"
  },
  "AG": {
    "en": "Antigua & Barbuda",
    "tr": "Antigua ve Barbuda",
    "es": "Antigua y Barbuda",
    "pt-BR": "Antígua e Barbuda",
    "fr": "Antigua-et-Barbuda",
    "de": "Antigua und Barbuda",
    "zh-Hans": "安提瓜和巴布达",
    "hi": "एंटिगुआ और बरबुडा",
    "ja": "アンティグア・バーブーダ",
    "ru": "Антигуа и Барбуда",
    "id": "Antigua dan Barbuda",
    "bn": "অ্যান্টিগুয়া ও বারবুডা"
  },
  "AI": {
    "en": "Anguilla",
    "tr": "Anguilla",
    "es": "Anguila",
    "pt-BR": "Anguila",
    "fr": "Anguilla",
    "de": "Anguilla",
    "zh-Hans": "安圭拉",
    "hi": "एंग्विला",
    "ja": "アンギラ",
    "ru": "Ангилья",
    "id": "Anguilla",
    "bn": "অ্যাঙ্গুইলা"
  },
  "AL": {
    "en": "Albania",
    "tr": "Arnavutluk",
    "es": "Albania",
    "pt-BR": "Albânia",
    "fr": "Albanie",
    "de": "Albanien",
    "zh-Hans": "阿尔巴尼亚",
    "hi": "अल्बानिया",
    "ja": "アルバニア",
    "ru": "Албания",
    "id": "Albania",
    "bn": "আলবেনিয়া"
  },
  "AM": {
    "en": "Armenia",
    "tr": "Ermenistan",
    "es": "Armenia",
    "pt-BR": "Armênia",
    "fr": "Arménie",
    "de": "Armenien",
    "zh-Hans": "亚美尼亚",
    "hi": "आर्मेनिया",
    "ja": "アルメニア",
    "ru": "Армения",
    "id": "Armenia",
    "bn": "আর্মেনিয়া"
  },
  "AN": {
    "en": "Curaçao",
    "tr": "Curaçao",
    "es": "Curazao",
    "pt-BR": "Curaçao",
    "fr": "Curaçao",
    "de": "Curaçao",
    "zh-Hans": "库拉索",
    "hi": "कुरासाओ",
    "ja": "キュラソー",
    "ru": "Кюрасао",
    "id": "Curaçao",
    "bn": "কুরাসাও"
  },
  "AO": {
    "en": "Angola",
    "tr": "Angola",
    "es": "Angola",
    "pt-BR": "Angola",
    "fr": "Angola",
    "de": "Angola",
    "zh-Hans": "安哥拉",
    "hi": "अंगोला",
    "ja": "アンゴラ",
    "ru": "Ангола",
    "id": "Angola",
    "bn": "অ্যাঙ্গোলা"
  },
  "AQ": {
    "en": "Antarctica",
    "tr": "Antarktika",
    "es": "Antártida",
    "pt-BR": "Antártida",
    "fr": "Antarctique",
    "de": "Antarktis",
    "zh-Hans": "南极洲",
    "hi": "अंटार्कटिका",
    "ja": "南極",
    "ru": "Антарктида",
    "id": "Antarktika",
    "bn": "অ্যান্টার্কটিকা"
  },
  "AR": {
    "en": "Argentina",
    "tr": "Arjantin",
    "es": "Argentina",
    "pt-BR": "Argentina",
    "fr": "Argentine",
    "de": "Argentinien",
    "zh-Hans": "阿根廷",
    "hi": "अर्जेंटीना",
    "ja": "アルゼンチン",
    "ru": "Аргентина",
    "id": "Argentina",
    "bn": "আর্জেন্টিনা"
  },
  "AS": {
    "en": "American Samoa",
    "tr": "Amerikan Samoası",
    "es": "Samoa Americana",
    "pt-BR": "Samoa Americana",
    "fr": "Samoa américaines",
    "de": "Amerikanisch-Samoa",
    "zh-Hans": "美属萨摩亚",
    "hi": "अमेरिकी समोआ",
    "ja": "米領サモア",
    "ru": "Американское Самоа",
    "id": "Samoa Amerika",
    "bn": "আমেরিকান সামোয়া"
  },
  "AT": {
    "en": "Austria",
    "tr": "Avusturya",
    "es": "Austria",
    "pt-BR": "Áustria",
    "fr": "Autriche",
    "de": "Österreich",
    "zh-Hans": "奥地利",
    "hi": "ऑस्ट्रिया",
    "ja": "オーストリア",
    "ru": "Австрия",
    "id": "Austria",
    "bn": "অস্ট্রিয়া"
  },
  "AU": {
    "en": "Australia",
    "tr": "Avustralya",
    "es": "Australia",
    "pt-BR": "Austrália",
    "fr": "Australie",
    "de": "Australien",
    "zh-Hans": "澳大利亚",
    "hi": "ऑस्ट्रेलिया",
    "ja": "オーストラリア",
    "ru": "Австралия",
    "id": "Australia",
    "bn": "অস্ট্রেলিয়া"
  },
  "AW": {
    "en": "Aruba",
    "tr": "Aruba",
    "es": "Aruba",
    "pt-BR": "Aruba",
    "fr": "Aruba",
    "de": "Aruba",
    "zh-Hans": "阿鲁巴",
    "hi": "अरूबा",
    "ja": "アルバ",
    "ru": "Аруба",
    "id": "Aruba",
    "bn": "আরুবা"
  },
  "AX": {
    "en": "Åland Islands",
    "tr": "Åland Adaları",
    "es": "Islas Aland",
    "pt-BR": "Ilhas Aland",
    "fr": "Îles Åland",
    "de": "Ålandinseln",
    "zh-Hans": "奥兰群岛",
    "hi": "एलैंड द्वीपसमूह",
    "ja": "オーランド諸島",
    "ru": "Аландские о-ва",
    "id": "Kepulauan Aland",
    "bn": "অলান্ড দ্বীপপুঞ্জ"
  },
  "AZ": {
    "en": "Azerbaijan",
    "tr": "Azerbaycan",
    "es": "Azerbaiyán",
    "pt-BR": "Azerbaijão",
    "fr": "Azerbaïdjan",
    "de": "Aserbaidschan",
    "zh-Hans": "阿塞拜疆",
    "hi": "अज़रबैजान",
    "ja": "アゼルバイジャン",
    "ru": "Азербайджан",
    "id": "Azerbaijan",
    "bn": "আজারবাইজান"
  },
  "BA": {
    "en": "Bosnia & Herzegovina",
    "tr": "Bosna-Hersek",
    "es": "Bosnia y Herzegovina",
    "pt-BR": "Bósnia e Herzegovina",
    "fr": "Bosnie-Herzégovine",
    "de": "Bosnien und Herzegowina",
    "zh-Hans": "波斯尼亚和黑塞哥维那",
    "hi": "बोस्निया और हर्ज़ेगोविना",
    "ja": "ボスニア・ヘルツェゴビナ",
    "ru": "Босния и Герцеговина",
    "id": "Bosnia dan Herzegovina",
    "bn": "বসনিয়া ও হার্জেগোভিনা"
  },
  "BB": {
    "en": "Barbados",
    "tr": "Barbados",
    "es": "Barbados",
    "pt-BR": "Barbados",
    "fr": "Barbade",
    "de": "Barbados",
    "zh-Hans": "巴巴多斯",
    "hi": "बारबाडोस",
    "ja": "バルバドス",
    "ru": "Барбадос",
    "id": "Barbados",
    "bn": "বার্বাডোজ"
  },
  "BD": {
    "en": "Bangladesh",
    "tr": "Bangladeş",
    "es": "Bangladés",
    "pt-BR": "Bangladesh",
    "fr": "Bangladesh",
    "de": "Bangladesch",
    "zh-Hans": "孟加拉国",
    "hi": "बांग्लादेश",
    "ja": "バングラデシュ",
    "ru": "Бангладеш",
    "id": "Bangladesh",
    "bn": "বাংলাদেশ"
  },
  "BE": {
    "en": "Belgium",
    "tr": "Belçika",
    "es": "Bélgica",
    "pt-BR": "Bélgica",
    "fr": "Belgique",
    "de": "Belgien",
    "zh-Hans": "比利时",
    "hi": "बेल्जियम",
    "ja": "ベルギー",
    "ru": "Бельгия",
    "id": "Belgia",
    "bn": "বেলজিয়াম"
  },
  "BF": {
    "en": "Burkina Faso",
    "tr": "Burkina Faso",
    "es": "Burkina Faso",
    "pt-BR": "Burquina Faso",
    "fr": "Burkina Faso",
    "de": "Burkina Faso",
    "zh-Hans": "布基纳法索",
    "hi": "बुर्किना फ़ासो",
    "ja": "ブルキナファソ",
    "ru": "Буркина-Фасо",
    "id": "Burkina Faso",
    "bn": "বুরকিনা ফাসো"
  },
  "BG": {
    "en": "Bulgaria",
    "tr": "Bulgaristan",
    "es": "Bulgaria",
    "pt-BR": "Bulgária",
    "fr": "Bulgarie",
    "de": "Bulgarien",
    "zh-Hans": "保加利亚",
    "hi": "बुल्गारिया",
    "ja": "ブルガリア",
    "ru": "Болгария",
    "id": "Bulgaria",
    "bn": "বুলগেরিয়া"
  },
  "BH": {
    "en": "Bahrain",
    "tr": "Bahreyn",
    "es": "Baréin",
    "pt-BR": "Barein",
    "fr": "Bahreïn",
    "de": "Bahrain",
    "zh-Hans": "巴林",
    "hi": "बहरीन",
    "ja": "バーレーン",
    "ru": "Бахрейн",
    "id": "Bahrain",
    "bn": "বাহারিন"
  },
  "BI": {
    "en": "Burundi",
    "tr": "Burundi",
    "es": "Burundi",
    "pt-BR": "Burundi",
    "fr": "Burundi",
    "de": "Burundi",
    "zh-Hans": "布隆迪",
    "hi": "बुरुंडी",
    "ja": "ブルンジ",
    "ru": "Бурунди",
    "id": "Burundi",
    "bn": "বুরুন্ডি"
  },
  "BJ": {
    "en": "Benin",
    "tr": "Benin",
    "es": "Benín",
    "pt-BR": "Benin",
    "fr": "Bénin",
    "de": "Benin",
    "zh-Hans": "贝宁",
    "hi": "बेनिन",
    "ja": "ベナン",
    "ru": "Бенин",
    "id": "Benin",
    "bn": "বেনিন"
  },
  "BL": {
    "en": "St. Barthélemy",
    "tr": "Saint Barthelemy",
    "es": "San Bartolomé",
    "pt-BR": "São Bartolomeu",
    "fr": "Saint-Barthélemy",
    "de": "St. Barthélemy",
    "zh-Hans": "圣巴泰勒米",
    "hi": "सेंट बार्थेलेमी",
    "ja": "サン・バルテルミー",
    "ru": "Сен-Бартелеми",
    "id": "Saint Barthélemy",
    "bn": "সেন্ট বার্থেলেমি"
  },
  "BM": {
    "en": "Bermuda",
    "tr": "Bermuda",
    "es": "Bermudas",
    "pt-BR": "Bermudas",
    "fr": "Bermudes",
    "de": "Bermuda",
    "zh-Hans": "百慕大",
    "hi": "बरमूडा",
    "ja": "バミューダ",
    "ru": "Бермудские о-ва",
    "id": "Bermuda",
    "bn": "বারমুডা"
  },
  "BN": {
    "en": "Brunei",
    "tr": "Brunei",
    "es": "Brunéi",
    "pt-BR": "Brunei",
    "fr": "Brunei",
    "de": "Brunei Darussalam",
    "zh-Hans": "文莱",
    "hi": "ब्रूनेई",
    "ja": "ブルネイ",
    "ru": "Бруней",
    "id": "Brunei",
    "bn": "ব্রুনেই"
  },
  "BO": {
    "en": "Bolivia",
    "tr": "Bolivya",
    "es": "Bolivia",
    "pt-BR": "Bolívia",
    "fr": "Bolivie",
    "de": "Bolivien",
    "zh-Hans": "玻利维亚",
    "hi": "बोलीविया",
    "ja": "ボリビア",
    "ru": "Боливия",
    "id": "Bolivia",
    "bn": "বলিভিয়া"
  },
  "BQ": {
    "en": "Caribbean Netherlands",
    "tr": "Karayip Hollandası",
    "es": "Caribe neerlandés",
    "pt-BR": "Países Baixos Caribenhos",
    "fr": "Pays-Bas caribéens",
    "de": "Karibische Niederlande",
    "zh-Hans": "荷属加勒比区",
    "hi": "कैरिबियन नीदरलैंड",
    "ja": "オランダ領カリブ",
    "ru": "Бонэйр, Синт-Эстатиус и Саба",
    "id": "Belanda Karibia",
    "bn": "ক্যারিবিয়ান নেদারল্যান্ডস"
  },
  "BR": {
    "en": "Brazil",
    "tr": "Brezilya",
    "es": "Brasil",
    "pt-BR": "Brasil",
    "fr": "Brésil",
    "de": "Brasilien",
    "zh-Hans": "巴西",
    "hi": "ब्राज़ील",
    "ja": "ブラジル",
    "ru": "Бразилия",
    "id": "Brasil",
    "bn": "ব্রাজিল"
  },
  "BS": {
    "en": "Bahamas",
    "tr": "Bahamalar",
    "es": "Bahamas",
    "pt-BR": "Bahamas",
    "fr": "Bahamas",
    "de": "Bahamas",
    "zh-Hans": "巴哈马",
    "hi": "बहामास",
    "ja": "バハマ",
    "ru": "Багамы",
    "id": "Bahama",
    "bn": "বাহামা দ্বীপপুঞ্জ"
  },
  "BT": {
    "en": "Bhutan",
    "tr": "Butan",
    "es": "Bután",
    "pt-BR": "Butão",
    "fr": "Bhoutan",
    "de": "Bhutan",
    "zh-Hans": "不丹",
    "hi": "भूटान",
    "ja": "ブータン",
    "ru": "Бутан",
    "id": "Bhutan",
    "bn": "ভুটান"
  },
  "BU": {
    "en": "Myanmar (Burma)",
    "tr": "Myanmar (Burma)",
    "es": "Myanmar (Birmania)",
    "pt-BR": "Mianmar (Birmânia)",
    "fr": "Myanmar (Birmanie)",
    "de": "Myanmar",
    "zh-Hans": "缅甸",
    "hi": "म्यांमार (बर्मा)",
    "ja": "ミャンマー (ビルマ)",
    "ru": "Мьянма (Бирма)",
    "id": "Myanmar (Burma)",
    "bn": "মায়ানমার (বার্মা)"
  },
  "BV": {
    "en": "Bouvet Island",
    "tr": "Bouvet Adası",
    "es": "Isla Bouvet",
    "pt-BR": "Ilha Bouvet",
    "fr": "Île Bouvet",
    "de": "Bouvetinsel",
    "zh-Hans": "布韦岛",
    "hi": "बोवेत द्वीप",
    "ja": "ブーベ島",
    "ru": "о-в Буве",
    "id": "Pulau Bouvet",
    "bn": "বোভেট দ্বীপ"
  },
  "BW": {
    "en": "Botswana",
    "tr": "Botsvana",
    "es": "Botsuana",
    "pt-BR": "Botsuana",
    "fr": "Botswana",
    "de": "Botsuana",
    "zh-Hans": "博茨瓦纳",
    "hi": "बोत्स्वाना",
    "ja": "ボツワナ",
    "ru": "Ботсвана",
    "id": "Botswana",
    "bn": "বতসোয়ানা"
  },
  "BY": {
    "en": "Belarus",
    "tr": "Belarus",
    "es": "Bielorrusia",
    "pt-BR": "Bielorrússia",
    "fr": "Biélorussie",
    "de": "Belarus",
    "zh-Hans": "白俄罗斯",
    "hi": "बेलारूस",
    "ja": "ベラルーシ",
    "ru": "Беларусь",
    "id": "Belarus",
    "bn": "বেলারুশ"
  },
  "BZ": {
    "en": "Belize",
    "tr": "Belize",
    "es": "Belice",
    "pt-BR": "Belize",
    "fr": "Belize",
    "de": "Belize",
    "zh-Hans": "伯利兹",
    "hi": "बेलीज़",
    "ja": "ベリーズ",
    "ru": "Белиз",
    "id": "Belize",
    "bn": "বেলিজ"
  },
  "CA": {
    "en": "Canada",
    "tr": "Kanada",
    "es": "Canadá",
    "pt-BR": "Canadá",
    "fr": "Canada",
    "de": "Kanada",
    "zh-Hans": "加拿大",
    "hi": "कनाडा",
    "ja": "カナダ",
    "ru": "Канада",
    "id": "Kanada",
    "bn": "কানাডা"
  },
  "CC": {
    "en": "Cocos (Keeling) Islands",
    "tr": "Cocos (Keeling) Adaları",
    "es": "Islas Cocos",
    "pt-BR": "Ilhas Cocos (Keeling)",
    "fr": "Îles Cocos",
    "de": "Kokosinseln",
    "zh-Hans": "科科斯（基林）群岛",
    "hi": "कोकोस (कीलिंग) द्वीपसमूह",
    "ja": "ココス(キーリング)諸島",
    "ru": "Кокосовые о-ва",
    "id": "Kepulauan Cocos (Keeling)",
    "bn": "কোকোস (কিলিং) দ্বীপপুঞ্জ"
  },
  "CD": {
    "en": "Congo - Kinshasa",
    "tr": "Kongo - Kinşasa",
    "es": "República Democrática del Congo",
    "pt-BR": "Congo - Kinshasa",
    "fr": "Congo-Kinshasa",
    "de": "Kongo-Kinshasa",
    "zh-Hans": "刚果（金）",
    "hi": "कांगो - किंशासा",
    "ja": "コンゴ民主共和国(キンシャサ)",
    "ru": "Конго - Киншаса",
    "id": "Kongo - Kinshasa",
    "bn": "কঙ্গো-কিনশাসা"
  },
  "CF": {
    "en": "Central African Republic",
    "tr": "Orta Afrika Cumhuriyeti",
    "es": "República Centroafricana",
    "pt-BR": "República Centro-Africana",
    "fr": "République centrafricaine",
    "de": "Zentralafrikanische Republik",
    "zh-Hans": "中非共和国",
    "hi": "मध्य अफ़्रीकी गणराज्य",
    "ja": "中央アフリカ共和国",
    "ru": "Центрально-Африканская Республика",
    "id": "Republik Afrika Tengah",
    "bn": "মধ্য আফ্রিকান প্রজাতন্ত্র"
  },
  "CG": {
    "en": "Congo - Brazzaville",
    "tr": "Kongo - Brazavil",
    "es": "Congo",
    "pt-BR": "República do Congo",
    "fr": "Congo-Brazzaville",
    "de": "Kongo-Brazzaville",
    "zh-Hans": "刚果（布）",
    "hi": "कांगो – ब्राज़ाविल",
    "ja": "コンゴ共和国(ブラザビル)",
    "ru": "Конго - Браззавиль",
    "id": "Kongo - Brazzaville",
    "bn": "কঙ্গো - ব্রাজাভিল"
  },
  "CH": {
    "en": "Switzerland",
    "tr": "İsviçre",
    "es": "Suiza",
    "pt-BR": "Suíça",
    "fr": "Suisse",
    "de": "Schweiz",
    "zh-Hans": "瑞士",
    "hi": "स्विट्ज़रलैंड",
    "ja": "スイス",
    "ru": "Швейцария",
    "id": "Swiss",
    "bn": "সুইজারল্যান্ড"
  },
  "CI": {
    "en": "Côte d’Ivoire",
    "tr": "Côte d’Ivoire",
    "es": "Côte d’Ivoire",
    "pt-BR": "Costa do Marfim",
    "fr": "Côte d’Ivoire",
    "de": "Côte d’Ivoire",
    "zh-Hans": "科特迪瓦",
    "hi": "कोत दिवुआर",
    "ja": "コートジボワール",
    "ru": "Кот-д’Ивуар",
    "id": "Côte d’Ivoire",
    "bn": "কোট ডি‘আইভোর"
  },
  "CK": {
    "en": "Cook Islands",
    "tr": "Cook Adaları",
    "es": "Islas Cook",
    "pt-BR": "Ilhas Cook",
    "fr": "Îles Cook",
    "de": "Cookinseln",
    "zh-Hans": "库克群岛",
    "hi": "कुक द्वीपसमूह",
    "ja": "クック諸島",
    "ru": "о-ва Кука",
    "id": "Kepulauan Cook",
    "bn": "কুক দ্বীপপুঞ্জ"
  },
  "CL": {
    "en": "Chile",
    "tr": "Şili",
    "es": "Chile",
    "pt-BR": "Chile",
    "fr": "Chili",
    "de": "Chile",
    "zh-Hans": "智利",
    "hi": "चिली",
    "ja": "チリ",
    "ru": "Чили",
    "id": "Cile",
    "bn": "চিলি"
  },
  "CM": {
    "en": "Cameroon",
    "tr": "Kamerun",
    "es": "Camerún",
    "pt-BR": "Camarões",
    "fr": "Cameroun",
    "de": "Kamerun",
    "zh-Hans": "喀麦隆",
    "hi": "कैमरून",
    "ja": "カメルーン",
    "ru": "Камерун",
    "id": "Kamerun",
    "bn": "ক্যামেরুন"
  },
  "CN": {
    "en": "China",
    "tr": "Çin",
    "es": "China",
    "pt-BR": "China",
    "fr": "Chine",
    "de": "China",
    "zh-Hans": "中国",
    "hi": "चीन",
    "ja": "中国",
    "ru": "Китай",
    "id": "Tiongkok",
    "bn": "চীন"
  },
  "CO": {
    "en": "Colombia",
    "tr": "Kolombiya",
    "es": "Colombia",
    "pt-BR": "Colômbia",
    "fr": "Colombie",
    "de": "Kolumbien",
    "zh-Hans": "哥伦比亚",
    "hi": "कोलंबिया",
    "ja": "コロンビア",
    "ru": "Колумбия",
    "id": "Kolombia",
    "bn": "কলম্বিয়া"
  },
  "CP": {
    "en": "Clipperton Island",
    "tr": "Clipperton Adası",
    "es": "Isla Clipperton",
    "pt-BR": "Ilha de Clipperton",
    "fr": "Île Clipperton",
    "de": "Clipperton-Insel",
    "zh-Hans": "克利珀顿岛",
    "hi": "क्लिपर्टन द्वीप",
    "ja": "クリッパートン島",
    "ru": "о-в Клиппертон",
    "id": "Pulau Clipperton",
    "bn": "ক্লিপারটন দ্বীপপুঞ্জ"
  },
  "CQ": {
    "en": "Sark",
    "tr": "Sark",
    "es": "Sark",
    "pt-BR": "Sark",
    "fr": "Sercq",
    "de": "Sark",
    "zh-Hans": "萨克岛",
    "hi": "सार्क",
    "ja": "サーク島",
    "ru": "Сарк",
    "id": "Sark",
    "bn": "সার্ক দ্বীপ"
  },
  "CR": {
    "en": "Costa Rica",
    "tr": "Kosta Rika",
    "es": "Costa Rica",
    "pt-BR": "Costa Rica",
    "fr": "Costa Rica",
    "de": "Costa Rica",
    "zh-Hans": "哥斯达黎加",
    "hi": "कोस्टारिका",
    "ja": "コスタリカ",
    "ru": "Коста-Рика",
    "id": "Kosta Rika",
    "bn": "কোস্টারিকা"
  },
  "CS": {
    "en": "Serbia",
    "tr": "Sırbistan",
    "es": "Serbia",
    "pt-BR": "Sérvia",
    "fr": "Serbie",
    "de": "Serbien",
    "zh-Hans": "塞尔维亚",
    "hi": "सर्बिया",
    "ja": "セルビア",
    "ru": "Сербия",
    "id": "Serbia",
    "bn": "সার্বিয়া"
  },
  "CU": {
    "en": "Cuba",
    "tr": "Küba",
    "es": "Cuba",
    "pt-BR": "Cuba",
    "fr": "Cuba",
    "de": "Kuba",
    "zh-Hans": "古巴",
    "hi": "क्यूबा",
    "ja": "キューバ",
    "ru": "Куба",
    "id": "Kuba",
    "bn": "কিউবা"
  },
  "CV": {
    "en": "Cape Verde",
    "tr": "Cabo Verde",
    "es": "Cabo Verde",
    "pt-BR": "Cabo Verde",
    "fr": "Cap-Vert",
    "de": "Cabo Verde",
    "zh-Hans": "佛得角",
    "hi": "केप वर्ड",
    "ja": "カーボベルデ",
    "ru": "Кабо-Верде",
    "id": "Tanjung Verde",
    "bn": "কেপ ভার্দে"
  },
  "CW": {
    "en": "Curaçao",
    "tr": "Curaçao",
    "es": "Curazao",
    "pt-BR": "Curaçao",
    "fr": "Curaçao",
    "de": "Curaçao",
    "zh-Hans": "库拉索",
    "hi": "कुरासाओ",
    "ja": "キュラソー",
    "ru": "Кюрасао",
    "id": "Curaçao",
    "bn": "কুরাসাও"
  },
  "CX": {
    "en": "Christmas Island",
    "tr": "Christmas Adası",
    "es": "Isla de Navidad",
    "pt-BR": "Ilha Christmas",
    "fr": "Île Christmas",
    "de": "Weihnachtsinsel",
    "zh-Hans": "圣诞岛",
    "hi": "क्रिसमस द्वीप",
    "ja": "クリスマス島",
    "ru": "о-в Рождества",
    "id": "Pulau Natal",
    "bn": "ক্রিসমাস দ্বীপ"
  },
  "CY": {
    "en": "Cyprus",
    "tr": "Kıbrıs",
    "es": "Chipre",
    "pt-BR": "Chipre",
    "fr": "Chypre",
    "de": "Zypern",
    "zh-Hans": "塞浦路斯",
    "hi": "साइप्रस",
    "ja": "キプロス",
    "ru": "Кипр",
    "id": "Siprus",
    "bn": "সাইপ্রাস"
  },
  "CZ": {
    "en": "Czechia",
    "tr": "Çekya",
    "es": "Chequia",
    "pt-BR": "Tchéquia",
    "fr": "Tchéquie",
    "de": "Tschechien",
    "zh-Hans": "捷克",
    "hi": "चेकिया",
    "ja": "チェコ",
    "ru": "Чехия",
    "id": "Ceko",
    "bn": "চেকিয়া"
  },
  "DD": {
    "en": "Germany",
    "tr": "Almanya",
    "es": "Alemania",
    "pt-BR": "Alemanha",
    "fr": "Allemagne",
    "de": "Deutschland",
    "zh-Hans": "德国",
    "hi": "जर्मनी",
    "ja": "ドイツ",
    "ru": "Германия",
    "id": "Jerman",
    "bn": "জার্মানি"
  },
  "DE": {
    "en": "Germany",
    "tr": "Almanya",
    "es": "Alemania",
    "pt-BR": "Alemanha",
    "fr": "Allemagne",
    "de": "Deutschland",
    "zh-Hans": "德国",
    "hi": "जर्मनी",
    "ja": "ドイツ",
    "ru": "Германия",
    "id": "Jerman",
    "bn": "জার্মানি"
  },
  "DG": {
    "en": "Diego Garcia",
    "tr": "Diego Garcia",
    "es": "Diego García",
    "pt-BR": "Diego Garcia",
    "fr": "Diego Garcia",
    "de": "Diego Garcia",
    "zh-Hans": "迪戈加西亚岛",
    "hi": "डिएगो गार्सिया",
    "ja": "ディエゴガルシア島",
    "ru": "Диего-Гарсия",
    "id": "Diego Garcia",
    "bn": "দিয়েগো গার্সিয়া"
  },
  "DJ": {
    "en": "Djibouti",
    "tr": "Cibuti",
    "es": "Yibuti",
    "pt-BR": "Djibuti",
    "fr": "Djibouti",
    "de": "Dschibuti",
    "zh-Hans": "吉布提",
    "hi": "जिबूती",
    "ja": "ジブチ",
    "ru": "Джибути",
    "id": "Jibuti",
    "bn": "জিবুতি"
  },
  "DK": {
    "en": "Denmark",
    "tr": "Danimarka",
    "es": "Dinamarca",
    "pt-BR": "Dinamarca",
    "fr": "Danemark",
    "de": "Dänemark",
    "zh-Hans": "丹麦",
    "hi": "डेनमार्क",
    "ja": "デンマーク",
    "ru": "Дания",
    "id": "Denmark",
    "bn": "ডেনমার্ক"
  },
  "DM": {
    "en": "Dominica",
    "tr": "Dominika",
    "es": "Dominica",
    "pt-BR": "Dominica",
    "fr": "Dominique",
    "de": "Dominica",
    "zh-Hans": "多米尼克",
    "hi": "डोमिनिका",
    "ja": "ドミニカ国",
    "ru": "Доминика",
    "id": "Dominika",
    "bn": "ডোমিনিকা"
  },
  "DO": {
    "en": "Dominican Republic",
    "tr": "Dominik Cumhuriyeti",
    "es": "República Dominicana",
    "pt-BR": "República Dominicana",
    "fr": "République dominicaine",
    "de": "Dominikanische Republik",
    "zh-Hans": "多米尼加共和国",
    "hi": "डोमिनिकन गणराज्य",
    "ja": "ドミニカ共和国",
    "ru": "Доминиканская Республика",
    "id": "Republik Dominika",
    "bn": "ডোমেনিকান প্রজাতন্ত্র"
  },
  "DY": {
    "en": "Benin",
    "tr": "Benin",
    "es": "Benín",
    "pt-BR": "Benin",
    "fr": "Bénin",
    "de": "Benin",
    "zh-Hans": "贝宁",
    "hi": "बेनिन",
    "ja": "ベナン",
    "ru": "Бенин",
    "id": "Benin",
    "bn": "বেনিন"
  },
  "DZ": {
    "en": "Algeria",
    "tr": "Cezayir",
    "es": "Argelia",
    "pt-BR": "Argélia",
    "fr": "Algérie",
    "de": "Algerien",
    "zh-Hans": "阿尔及利亚",
    "hi": "अल्जीरिया",
    "ja": "アルジェリア",
    "ru": "Алжир",
    "id": "Aljazair",
    "bn": "আলজেরিয়া"
  },
  "EA": {
    "en": "Ceuta & Melilla",
    "tr": "Ceuta ve Melilla",
    "es": "Ceuta y Melilla",
    "pt-BR": "Ceuta e Melilla",
    "fr": "Ceuta et Melilla",
    "de": "Ceuta und Melilla",
    "zh-Hans": "休达及梅利利亚",
    "hi": "सेउटा और मेलिला",
    "ja": "セウタ・メリリャ",
    "ru": "Сеута и Мелилья",
    "id": "Ceuta dan Melilla",
    "bn": "কুউটা এবং মেলিলা"
  },
  "EC": {
    "en": "Ecuador",
    "tr": "Ekvador",
    "es": "Ecuador",
    "pt-BR": "Equador",
    "fr": "Équateur",
    "de": "Ecuador",
    "zh-Hans": "厄瓜多尔",
    "hi": "इक्वाडोर",
    "ja": "エクアドル",
    "ru": "Эквадор",
    "id": "Ekuador",
    "bn": "ইকুয়েডর"
  },
  "EE": {
    "en": "Estonia",
    "tr": "Estonya",
    "es": "Estonia",
    "pt-BR": "Estônia",
    "fr": "Estonie",
    "de": "Estland",
    "zh-Hans": "爱沙尼亚",
    "hi": "एस्टोनिया",
    "ja": "エストニア",
    "ru": "Эстония",
    "id": "Estonia",
    "bn": "এস্তোনিয়া"
  },
  "EG": {
    "en": "Egypt",
    "tr": "Mısır",
    "es": "Egipto",
    "pt-BR": "Egito",
    "fr": "Égypte",
    "de": "Ägypten",
    "zh-Hans": "埃及",
    "hi": "मिस्र",
    "ja": "エジプト",
    "ru": "Египет",
    "id": "Mesir",
    "bn": "মিশর"
  },
  "EH": {
    "en": "Western Sahara",
    "tr": "Batı Sahra",
    "es": "Sáhara Occidental",
    "pt-BR": "Saara Ocidental",
    "fr": "Sahara occidental",
    "de": "Westsahara",
    "zh-Hans": "西撒哈拉",
    "hi": "पश्चिमी सहारा",
    "ja": "西サハラ",
    "ru": "Западная Сахара",
    "id": "Sahara Barat",
    "bn": "পশ্চিম সাহারা"
  },
  "ER": {
    "en": "Eritrea",
    "tr": "Eritre",
    "es": "Eritrea",
    "pt-BR": "Eritreia",
    "fr": "Érythrée",
    "de": "Eritrea",
    "zh-Hans": "厄立特里亚",
    "hi": "इरिट्रिया",
    "ja": "エリトリア",
    "ru": "Эритрея",
    "id": "Eritrea",
    "bn": "ইরিত্রিয়া"
  },
  "ES": {
    "en": "Spain",
    "tr": "İspanya",
    "es": "España",
    "pt-BR": "Espanha",
    "fr": "Espagne",
    "de": "Spanien",
    "zh-Hans": "西班牙",
    "hi": "स्पेन",
    "ja": "スペイン",
    "ru": "Испания",
    "id": "Spanyol",
    "bn": "স্পেন"
  },
  "ET": {
    "en": "Ethiopia",
    "tr": "Etiyopya",
    "es": "Etiopía",
    "pt-BR": "Etiópia",
    "fr": "Éthiopie",
    "de": "Äthiopien",
    "zh-Hans": "埃塞俄比亚",
    "hi": "इथियोपिया",
    "ja": "エチオピア",
    "ru": "Эфиопия",
    "id": "Etiopia",
    "bn": "ইথিওপিয়া"
  },
  "EU": {
    "en": "European Union",
    "tr": "Avrupa Birliği",
    "es": "Unión Europea",
    "pt-BR": "União Europeia",
    "fr": "Union européenne",
    "de": "Europäische Union",
    "zh-Hans": "欧盟",
    "hi": "यूरोपीय संघ",
    "ja": "欧州連合",
    "ru": "Европейский союз",
    "id": "Uni Eropa",
    "bn": "ইউরোপীয় ইউনিয়ন"
  },
  "EZ": {
    "en": "Eurozone",
    "tr": "Euro Bölgesi",
    "es": "zona del euro",
    "pt-BR": "zona do euro",
    "fr": "zone euro",
    "de": "Eurozone",
    "zh-Hans": "欧元区",
    "hi": "यूरोज़ोन",
    "ja": "ユーロ圏",
    "ru": "еврозона",
    "id": "Zona Euro",
    "bn": "ইউরোজোন"
  },
  "FI": {
    "en": "Finland",
    "tr": "Finlandiya",
    "es": "Finlandia",
    "pt-BR": "Finlândia",
    "fr": "Finlande",
    "de": "Finnland",
    "zh-Hans": "芬兰",
    "hi": "फ़िनलैंड",
    "ja": "フィンランド",
    "ru": "Финляндия",
    "id": "Finlandia",
    "bn": "ফিনল্যান্ড"
  },
  "FJ": {
    "en": "Fiji",
    "tr": "Fiji",
    "es": "Fiyi",
    "pt-BR": "Fiji",
    "fr": "Fidji",
    "de": "Fidschi",
    "zh-Hans": "斐济",
    "hi": "फ़िजी",
    "ja": "フィジー",
    "ru": "Фиджи",
    "id": "Fiji",
    "bn": "ফিজি"
  },
  "FK": {
    "en": "Falkland Islands",
    "tr": "Falkland Adaları",
    "es": "Islas Malvinas",
    "pt-BR": "Ilhas Malvinas",
    "fr": "Îles Malouines",
    "de": "Falklandinseln",
    "zh-Hans": "福克兰群岛",
    "hi": "फ़ॉकलैंड द्वीपसमूह",
    "ja": "フォークランド諸島",
    "ru": "Фолклендские о-ва",
    "id": "Kepulauan Falkland",
    "bn": "ফকল্যান্ড দ্বীপপুঞ্জ"
  },
  "FM": {
    "en": "Micronesia",
    "tr": "Mikronezya",
    "es": "Micronesia",
    "pt-BR": "Micronésia",
    "fr": "Micronésie",
    "de": "Mikronesien",
    "zh-Hans": "密克罗尼西亚",
    "hi": "माइक्रोनेशिया",
    "ja": "ミクロネシア連邦",
    "ru": "Федеративные Штаты Микронезии",
    "id": "Mikronesia",
    "bn": "মাইক্রোনেশিয়া"
  },
  "FO": {
    "en": "Faroe Islands",
    "tr": "Faroe Adaları",
    "es": "Islas Feroe",
    "pt-BR": "Ilhas Faroé",
    "fr": "Îles Féroé",
    "de": "Färöer",
    "zh-Hans": "法罗群岛",
    "hi": "फ़ेरो द्वीपसमूह",
    "ja": "フェロー諸島",
    "ru": "Фарерские о-ва",
    "id": "Kepulauan Faroe",
    "bn": "ফ্যারো দ্বীপপুঞ্জ"
  },
  "FR": {
    "en": "France",
    "tr": "Fransa",
    "es": "Francia",
    "pt-BR": "França",
    "fr": "France",
    "de": "Frankreich",
    "zh-Hans": "法国",
    "hi": "फ़्रांस",
    "ja": "フランス",
    "ru": "Франция",
    "id": "Prancis",
    "bn": "ফ্রান্স"
  },
  "FX": {
    "en": "France",
    "tr": "Fransa",
    "es": "Francia",
    "pt-BR": "França",
    "fr": "France",
    "de": "Frankreich",
    "zh-Hans": "法国",
    "hi": "फ़्रांस",
    "ja": "フランス",
    "ru": "Франция",
    "id": "Prancis",
    "bn": "ফ্রান্স"
  },
  "GA": {
    "en": "Gabon",
    "tr": "Gabon",
    "es": "Gabón",
    "pt-BR": "Gabão",
    "fr": "Gabon",
    "de": "Gabun",
    "zh-Hans": "加蓬",
    "hi": "गैबॉन",
    "ja": "ガボン",
    "ru": "Габон",
    "id": "Gabon",
    "bn": "গ্যাবন"
  },
  "GB": {
    "en": "United Kingdom",
    "tr": "Birleşik Krallık",
    "es": "Reino Unido",
    "pt-BR": "Reino Unido",
    "fr": "Royaume-Uni",
    "de": "Vereinigtes Königreich",
    "zh-Hans": "英国",
    "hi": "यूनाइटेड किंगडम",
    "ja": "イギリス",
    "ru": "Великобритания",
    "id": "Inggris Raya",
    "bn": "যুক্তরাজ্য"
  },
  "GD": {
    "en": "Grenada",
    "tr": "Grenada",
    "es": "Granada",
    "pt-BR": "Granada",
    "fr": "Grenade",
    "de": "Grenada",
    "zh-Hans": "格林纳达",
    "hi": "ग्रेनाडा",
    "ja": "グレナダ",
    "ru": "Гренада",
    "id": "Grenada",
    "bn": "গ্রেনাডা"
  },
  "GE": {
    "en": "Georgia",
    "tr": "Gürcistan",
    "es": "Georgia",
    "pt-BR": "Geórgia",
    "fr": "Géorgie",
    "de": "Georgien",
    "zh-Hans": "格鲁吉亚",
    "hi": "जॉर्जिया",
    "ja": "ジョージア",
    "ru": "Грузия",
    "id": "Georgia",
    "bn": "জর্জিয়া"
  },
  "GF": {
    "en": "French Guiana",
    "tr": "Fransız Guyanası",
    "es": "Guayana Francesa",
    "pt-BR": "Guiana Francesa",
    "fr": "Guyane française",
    "de": "Französisch-Guayana",
    "zh-Hans": "法属圭亚那",
    "hi": "फ़्रेंच गुयाना",
    "ja": "仏領ギアナ",
    "ru": "Французская Гвиана",
    "id": "Guyana Prancis",
    "bn": "ফরাসী গায়ানা"
  },
  "GG": {
    "en": "Guernsey",
    "tr": "Guernsey",
    "es": "Guernesey",
    "pt-BR": "Guernsey",
    "fr": "Guernesey",
    "de": "Guernsey",
    "zh-Hans": "根西岛",
    "hi": "गर्नसी",
    "ja": "ガーンジー",
    "ru": "Гернси",
    "id": "Guernsey",
    "bn": "গার্নসি"
  },
  "GH": {
    "en": "Ghana",
    "tr": "Gana",
    "es": "Ghana",
    "pt-BR": "Gana",
    "fr": "Ghana",
    "de": "Ghana",
    "zh-Hans": "加纳",
    "hi": "घाना",
    "ja": "ガーナ",
    "ru": "Гана",
    "id": "Ghana",
    "bn": "ঘানা"
  },
  "GI": {
    "en": "Gibraltar",
    "tr": "Cebelitarık",
    "es": "Gibraltar",
    "pt-BR": "Gibraltar",
    "fr": "Gibraltar",
    "de": "Gibraltar",
    "zh-Hans": "直布罗陀",
    "hi": "जिब्राल्टर",
    "ja": "ジブラルタル",
    "ru": "Гибралтар",
    "id": "Gibraltar",
    "bn": "জিব্রাল্টার"
  },
  "GL": {
    "en": "Greenland",
    "tr": "Grönland",
    "es": "Groenlandia",
    "pt-BR": "Groenlândia",
    "fr": "Groenland",
    "de": "Grönland",
    "zh-Hans": "格陵兰",
    "hi": "ग्रीनलैंड",
    "ja": "グリーンランド",
    "ru": "Гренландия",
    "id": "Greenland",
    "bn": "গ্রীনল্যান্ড"
  },
  "GM": {
    "en": "Gambia",
    "tr": "Gambiya",
    "es": "Gambia",
    "pt-BR": "Gâmbia",
    "fr": "Gambie",
    "de": "Gambia",
    "zh-Hans": "冈比亚",
    "hi": "गाम्बिया",
    "ja": "ガンビア",
    "ru": "Гамбия",
    "id": "Gambia",
    "bn": "গাম্বিয়া"
  },
  "GN": {
    "en": "Guinea",
    "tr": "Gine",
    "es": "Guinea",
    "pt-BR": "Guiné",
    "fr": "Guinée",
    "de": "Guinea",
    "zh-Hans": "几内亚",
    "hi": "गिनी",
    "ja": "ギニア",
    "ru": "Гвинея",
    "id": "Guinea",
    "bn": "গিনি"
  },
  "GP": {
    "en": "Guadeloupe",
    "tr": "Guadeloupe",
    "es": "Guadalupe",
    "pt-BR": "Guadalupe",
    "fr": "Guadeloupe",
    "de": "Guadeloupe",
    "zh-Hans": "瓜德罗普",
    "hi": "ग्वाडेलूप",
    "ja": "グアドループ",
    "ru": "Гваделупа",
    "id": "Guadeloupe",
    "bn": "গুয়াদেলৌপ"
  },
  "GQ": {
    "en": "Equatorial Guinea",
    "tr": "Ekvator Ginesi",
    "es": "Guinea Ecuatorial",
    "pt-BR": "Guiné Equatorial",
    "fr": "Guinée équatoriale",
    "de": "Äquatorialguinea",
    "zh-Hans": "赤道几内亚",
    "hi": "इक्वेटोरियल गिनी",
    "ja": "赤道ギニア",
    "ru": "Экваториальная Гвинея",
    "id": "Guinea Ekuatorial",
    "bn": "নিরক্ষীয় গিনি"
  },
  "GR": {
    "en": "Greece",
    "tr": "Yunanistan",
    "es": "Grecia",
    "pt-BR": "Grécia",
    "fr": "Grèce",
    "de": "Griechenland",
    "zh-Hans": "希腊",
    "hi": "यूनान",
    "ja": "ギリシャ",
    "ru": "Греция",
    "id": "Yunani",
    "bn": "গ্রীস"
  },
  "GS": {
    "en": "South Georgia & South Sandwich Islands",
    "tr": "Güney Georgia ve Güney Sandwich Adaları",
    "es": "Islas Georgia del Sur y Sandwich del Sur",
    "pt-BR": "Ilhas Geórgia do Sul e Sandwich do Sul",
    "fr": "Géorgie du Sud-et-les Îles Sandwich du Sud",
    "de": "Südgeorgien und die Südlichen Sandwichinseln",
    "zh-Hans": "南乔治亚和南桑威奇群岛",
    "hi": "दक्षिण जॉर्जिया और दक्षिण सैंडविच द्वीपसमूह",
    "ja": "サウスジョージア・サウスサンドウィッチ諸島",
    "ru": "Южная Георгия и Южные Сандвичевы о-ва",
    "id": "Georgia Selatan & Kep. Sandwich Selatan",
    "bn": "দক্ষিণ জর্জিয়া ও দক্ষিণ স্যান্ডউইচ দ্বীপপুঞ্জ"
  },
  "GT": {
    "en": "Guatemala",
    "tr": "Guatemala",
    "es": "Guatemala",
    "pt-BR": "Guatemala",
    "fr": "Guatemala",
    "de": "Guatemala",
    "zh-Hans": "危地马拉",
    "hi": "ग्वाटेमाला",
    "ja": "グアテマラ",
    "ru": "Гватемала",
    "id": "Guatemala",
    "bn": "গুয়াতেমালা"
  },
  "GU": {
    "en": "Guam",
    "tr": "Guam",
    "es": "Guam",
    "pt-BR": "Guam",
    "fr": "Guam",
    "de": "Guam",
    "zh-Hans": "关岛",
    "hi": "गुआम",
    "ja": "グアム",
    "ru": "Гуам",
    "id": "Guam",
    "bn": "গুয়াম"
  },
  "GW": {
    "en": "Guinea-Bissau",
    "tr": "Gine-Bissau",
    "es": "Guinea-Bisáu",
    "pt-BR": "Guiné-Bissau",
    "fr": "Guinée-Bissau",
    "de": "Guinea-Bissau",
    "zh-Hans": "几内亚比绍",
    "hi": "गिनी-बिसाउ",
    "ja": "ギニアビサウ",
    "ru": "Гвинея-Бисау",
    "id": "Guinea-Bissau",
    "bn": "গিনি-বিসাউ"
  },
  "GY": {
    "en": "Guyana",
    "tr": "Guyana",
    "es": "Guyana",
    "pt-BR": "Guiana",
    "fr": "Guyana",
    "de": "Guyana",
    "zh-Hans": "圭亚那",
    "hi": "गुयाना",
    "ja": "ガイアナ",
    "ru": "Гайана",
    "id": "Guyana",
    "bn": "গিয়ানা"
  },
  "HK": {
    "en": "Hong Kong SAR China",
    "tr": "Çin Hong Kong ÖİB",
    "es": "RAE de Hong Kong (China)",
    "pt-BR": "Hong Kong, RAE da China",
    "fr": "R.A.S. chinoise de Hong Kong",
    "de": "Sonderverwaltungsregion Hongkong",
    "zh-Hans": "中国香港特别行政区",
    "hi": "हाँग काँग (चीन विशेष प्रशासनिक क्षेत्र)",
    "ja": "中華人民共和国香港特別行政区",
    "ru": "Гонконг (САР)",
    "id": "Hong Kong DAK Tiongkok",
    "bn": "হংকং এসএআর চীনা"
  },
  "HM": {
    "en": "Heard & McDonald Islands",
    "tr": "Heard Adası ve McDonald Adaları",
    "es": "Islas Heard y McDonald",
    "pt-BR": "Ilhas Heard e McDonald",
    "fr": "Îles Heard-et-MacDonald",
    "de": "Heard und McDonaldinseln",
    "zh-Hans": "赫德岛和麦克唐纳群岛",
    "hi": "हर्ड द्वीप और मैकडोनॉल्ड द्वीपसमूह",
    "ja": "ハード島・マクドナルド諸島",
    "ru": "о-ва Херд и Макдональд",
    "id": "Pulau Heard dan Kepulauan McDonald",
    "bn": "হার্ড এবং ম্যাকডোনাল্ড দ্বীপপুঞ্জ"
  },
  "HN": {
    "en": "Honduras",
    "tr": "Honduras",
    "es": "Honduras",
    "pt-BR": "Honduras",
    "fr": "Honduras",
    "de": "Honduras",
    "zh-Hans": "洪都拉斯",
    "hi": "होंडूरास",
    "ja": "ホンジュラス",
    "ru": "Гондурас",
    "id": "Honduras",
    "bn": "হন্ডুরাস"
  },
  "HR": {
    "en": "Croatia",
    "tr": "Hırvatistan",
    "es": "Croacia",
    "pt-BR": "Croácia",
    "fr": "Croatie",
    "de": "Kroatien",
    "zh-Hans": "克罗地亚",
    "hi": "क्रोएशिया",
    "ja": "クロアチア",
    "ru": "Хорватия",
    "id": "Kroasia",
    "bn": "ক্রোয়েশিয়া"
  },
  "HT": {
    "en": "Haiti",
    "tr": "Haiti",
    "es": "Haití",
    "pt-BR": "Haiti",
    "fr": "Haïti",
    "de": "Haiti",
    "zh-Hans": "海地",
    "hi": "हैती",
    "ja": "ハイチ",
    "ru": "Гаити",
    "id": "Haiti",
    "bn": "হাইতি"
  },
  "HU": {
    "en": "Hungary",
    "tr": "Macaristan",
    "es": "Hungría",
    "pt-BR": "Hungria",
    "fr": "Hongrie",
    "de": "Ungarn",
    "zh-Hans": "匈牙利",
    "hi": "हंगरी",
    "ja": "ハンガリー",
    "ru": "Венгрия",
    "id": "Hungaria",
    "bn": "হাঙ্গেরি"
  },
  "HV": {
    "en": "Burkina Faso",
    "tr": "Burkina Faso",
    "es": "Burkina Faso",
    "pt-BR": "Burquina Faso",
    "fr": "Burkina Faso",
    "de": "Burkina Faso",
    "zh-Hans": "布基纳法索",
    "hi": "बुर्किना फ़ासो",
    "ja": "ブルキナファソ",
    "ru": "Буркина-Фасо",
    "id": "Burkina Faso",
    "bn": "বুরকিনা ফাসো"
  },
  "IC": {
    "en": "Canary Islands",
    "tr": "Kanarya Adaları",
    "es": "Canarias",
    "pt-BR": "Ilhas Canárias",
    "fr": "Îles Canaries",
    "de": "Kanarische Inseln",
    "zh-Hans": "加纳利群岛",
    "hi": "कैनेरी द्वीपसमूह",
    "ja": "カナリア諸島",
    "ru": "Канарские о-ва",
    "id": "Kepulauan Canaria",
    "bn": "ক্যানারি দ্বীপপুঞ্জ"
  },
  "ID": {
    "en": "Indonesia",
    "tr": "Endonezya",
    "es": "Indonesia",
    "pt-BR": "Indonésia",
    "fr": "Indonésie",
    "de": "Indonesien",
    "zh-Hans": "印度尼西亚",
    "hi": "इंडोनेशिया",
    "ja": "インドネシア",
    "ru": "Индонезия",
    "id": "Indonesia",
    "bn": "ইন্দোনেশিয়া"
  },
  "IE": {
    "en": "Ireland",
    "tr": "İrlanda",
    "es": "Irlanda",
    "pt-BR": "Irlanda",
    "fr": "Irlande",
    "de": "Irland",
    "zh-Hans": "爱尔兰",
    "hi": "आयरलैंड",
    "ja": "アイルランド",
    "ru": "Ирландия",
    "id": "Irlandia",
    "bn": "আয়ারল্যান্ড"
  },
  "IL": {
    "en": "Israel",
    "tr": "İsrail",
    "es": "Israel",
    "pt-BR": "Israel",
    "fr": "Israël",
    "de": "Israel",
    "zh-Hans": "以色列",
    "hi": "इज़राइल",
    "ja": "イスラエル",
    "ru": "Израиль",
    "id": "Israel",
    "bn": "ইজরায়েল"
  },
  "IM": {
    "en": "Isle of Man",
    "tr": "Man Adası",
    "es": "Isla de Man",
    "pt-BR": "Ilha de Man",
    "fr": "Île de Man",
    "de": "Isle of Man",
    "zh-Hans": "马恩岛",
    "hi": "आइल ऑफ़ मैन",
    "ja": "マン島",
    "ru": "о-в Мэн",
    "id": "Pulau Man",
    "bn": "আইল অফ ম্যান"
  },
  "IN": {
    "en": "India",
    "tr": "Hindistan",
    "es": "India",
    "pt-BR": "Índia",
    "fr": "Inde",
    "de": "Indien",
    "zh-Hans": "印度",
    "hi": "भारत",
    "ja": "インド",
    "ru": "Индия",
    "id": "India",
    "bn": "ভারত"
  },
  "IO": {
    "en": "British Indian Ocean Territory",
    "tr": "Britanya Hint Okyanusu Toprakları",
    "es": "Territorio Británico del Océano Índico",
    "pt-BR": "Território Britânico do Oceano Índico",
    "fr": "Territoire britannique de l’océan Indien",
    "de": "Britisches Territorium im Indischen Ozean",
    "zh-Hans": "英属印度洋领地",
    "hi": "ब्रिटिश हिंद महासागरीय क्षेत्र",
    "ja": "英領インド洋地域",
    "ru": "Британская территория в Индийском океане",
    "id": "Wilayah Inggris di Samudra Hindia",
    "bn": "ব্রিটিশ ভারত মহাসাগরীয় অঞ্চল"
  },
  "IQ": {
    "en": "Iraq",
    "tr": "Irak",
    "es": "Irak",
    "pt-BR": "Iraque",
    "fr": "Irak",
    "de": "Irak",
    "zh-Hans": "伊拉克",
    "hi": "इराक",
    "ja": "イラク",
    "ru": "Ирак",
    "id": "Irak",
    "bn": "ইরাক"
  },
  "IR": {
    "en": "Iran",
    "tr": "İran",
    "es": "Irán",
    "pt-BR": "Irã",
    "fr": "Iran",
    "de": "Iran",
    "zh-Hans": "伊朗",
    "hi": "ईरान",
    "ja": "イラン",
    "ru": "Иран",
    "id": "Iran",
    "bn": "ইরান"
  },
  "IS": {
    "en": "Iceland",
    "tr": "İzlanda",
    "es": "Islandia",
    "pt-BR": "Islândia",
    "fr": "Islande",
    "de": "Island",
    "zh-Hans": "冰岛",
    "hi": "आइसलैंड",
    "ja": "アイスランド",
    "ru": "Исландия",
    "id": "Islandia",
    "bn": "আইসল্যান্ড"
  },
  "IT": {
    "en": "Italy",
    "tr": "İtalya",
    "es": "Italia",
    "pt-BR": "Itália",
    "fr": "Italie",
    "de": "Italien",
    "zh-Hans": "意大利",
    "hi": "इटली",
    "ja": "イタリア",
    "ru": "Италия",
    "id": "Italia",
    "bn": "ইতালি"
  },
  "JE": {
    "en": "Jersey",
    "tr": "Jersey",
    "es": "Jersey",
    "pt-BR": "Jersey",
    "fr": "Jersey",
    "de": "Jersey",
    "zh-Hans": "泽西岛",
    "hi": "जर्सी",
    "ja": "ジャージー",
    "ru": "Джерси",
    "id": "Jersey",
    "bn": "জার্সি"
  },
  "JM": {
    "en": "Jamaica",
    "tr": "Jamaika",
    "es": "Jamaica",
    "pt-BR": "Jamaica",
    "fr": "Jamaïque",
    "de": "Jamaika",
    "zh-Hans": "牙买加",
    "hi": "जमैका",
    "ja": "ジャマイカ",
    "ru": "Ямайка",
    "id": "Jamaika",
    "bn": "জামাইকা"
  },
  "JO": {
    "en": "Jordan",
    "tr": "Ürdün",
    "es": "Jordania",
    "pt-BR": "Jordânia",
    "fr": "Jordanie",
    "de": "Jordanien",
    "zh-Hans": "约旦",
    "hi": "जॉर्डन",
    "ja": "ヨルダン",
    "ru": "Иордания",
    "id": "Yordania",
    "bn": "জর্ডন"
  },
  "JP": {
    "en": "Japan",
    "tr": "Japonya",
    "es": "Japón",
    "pt-BR": "Japão",
    "fr": "Japon",
    "de": "Japan",
    "zh-Hans": "日本",
    "hi": "जापान",
    "ja": "日本",
    "ru": "Япония",
    "id": "Jepang",
    "bn": "জাপান"
  },
  "KE": {
    "en": "Kenya",
    "tr": "Kenya",
    "es": "Kenia",
    "pt-BR": "Quênia",
    "fr": "Kenya",
    "de": "Kenia",
    "zh-Hans": "肯尼亚",
    "hi": "केन्या",
    "ja": "ケニア",
    "ru": "Кения",
    "id": "Kenya",
    "bn": "কেনিয়া"
  },
  "KG": {
    "en": "Kyrgyzstan",
    "tr": "Kırgızistan",
    "es": "Kirguistán",
    "pt-BR": "Quirguistão",
    "fr": "Kirghizstan",
    "de": "Kirgisistan",
    "zh-Hans": "吉尔吉斯斯坦",
    "hi": "किर्गिज़स्तान",
    "ja": "キルギス",
    "ru": "Киргизия",
    "id": "Kirgizstan",
    "bn": "কিরগিজিস্তান"
  },
  "KH": {
    "en": "Cambodia",
    "tr": "Kamboçya",
    "es": "Camboya",
    "pt-BR": "Camboja",
    "fr": "Cambodge",
    "de": "Kambodscha",
    "zh-Hans": "柬埔寨",
    "hi": "कंबोडिया",
    "ja": "カンボジア",
    "ru": "Камбоджа",
    "id": "Kamboja",
    "bn": "কম্বোডিয়া"
  },
  "KI": {
    "en": "Kiribati",
    "tr": "Kiribati",
    "es": "Kiribati",
    "pt-BR": "Quiribati",
    "fr": "Kiribati",
    "de": "Kiribati",
    "zh-Hans": "基里巴斯",
    "hi": "किरिबाती",
    "ja": "キリバス",
    "ru": "Кирибати",
    "id": "Kiribati",
    "bn": "কিরিবাতি"
  },
  "KM": {
    "en": "Comoros",
    "tr": "Komorlar",
    "es": "Comoras",
    "pt-BR": "Comores",
    "fr": "Comores",
    "de": "Komoren",
    "zh-Hans": "科摩罗",
    "hi": "कोमोरोस",
    "ja": "コモロ",
    "ru": "Коморы",
    "id": "Komoro",
    "bn": "কমোরোস"
  },
  "KN": {
    "en": "St. Kitts & Nevis",
    "tr": "Saint Kitts ve Nevis",
    "es": "San Cristóbal y Nieves",
    "pt-BR": "São Cristóvão e Névis",
    "fr": "Saint-Christophe-et-Niévès",
    "de": "St. Kitts und Nevis",
    "zh-Hans": "圣基茨和尼维斯",
    "hi": "सेंट किट्स और नेविस",
    "ja": "セントクリストファー・ネーヴィス",
    "ru": "Сент-Китс и Невис",
    "id": "Saint Kitts dan Nevis",
    "bn": "সেন্ট কিটস ও নেভিস"
  },
  "KP": {
    "en": "North Korea",
    "tr": "Kuzey Kore",
    "es": "Corea del Norte",
    "pt-BR": "Coreia do Norte",
    "fr": "Corée du Nord",
    "de": "Nordkorea",
    "zh-Hans": "朝鲜",
    "hi": "उत्तर कोरिया",
    "ja": "北朝鮮",
    "ru": "КНДР",
    "id": "Korea Utara",
    "bn": "উত্তর কোরিয়া"
  },
  "KR": {
    "en": "South Korea",
    "tr": "Güney Kore",
    "es": "Corea del Sur",
    "pt-BR": "Coreia do Sul",
    "fr": "Corée du Sud",
    "de": "Südkorea",
    "zh-Hans": "韩国",
    "hi": "दक्षिण कोरिया",
    "ja": "韓国",
    "ru": "Республика Корея",
    "id": "Korea Selatan",
    "bn": "দক্ষিণ কোরিয়া"
  },
  "KW": {
    "en": "Kuwait",
    "tr": "Kuveyt",
    "es": "Kuwait",
    "pt-BR": "Kuwait",
    "fr": "Koweït",
    "de": "Kuwait",
    "zh-Hans": "科威特",
    "hi": "कुवैत",
    "ja": "クウェート",
    "ru": "Кувейт",
    "id": "Kuwait",
    "bn": "কুয়েত"
  },
  "KY": {
    "en": "Cayman Islands",
    "tr": "Cayman Adaları",
    "es": "Islas Caimán",
    "pt-BR": "Ilhas Cayman",
    "fr": "Îles Caïmans",
    "de": "Kaimaninseln",
    "zh-Hans": "开曼群岛",
    "hi": "कैमेन द्वीपसमूह",
    "ja": "ケイマン諸島",
    "ru": "о-ва Кайман",
    "id": "Kepulauan Cayman",
    "bn": "কেম্যান দ্বীপপুঞ্জ"
  },
  "KZ": {
    "en": "Kazakhstan",
    "tr": "Kazakistan",
    "es": "Kazajistán",
    "pt-BR": "Cazaquistão",
    "fr": "Kazakhstan",
    "de": "Kasachstan",
    "zh-Hans": "哈萨克斯坦",
    "hi": "कज़ाखस्तान",
    "ja": "カザフスタン",
    "ru": "Казахстан",
    "id": "Kazakhstan",
    "bn": "কাজাখস্তান"
  },
  "LA": {
    "en": "Laos",
    "tr": "Laos",
    "es": "Laos",
    "pt-BR": "Laos",
    "fr": "Laos",
    "de": "Laos",
    "zh-Hans": "老挝",
    "hi": "लाओस",
    "ja": "ラオス",
    "ru": "Лаос",
    "id": "Laos",
    "bn": "লাওস"
  },
  "LB": {
    "en": "Lebanon",
    "tr": "Lübnan",
    "es": "Líbano",
    "pt-BR": "Líbano",
    "fr": "Liban",
    "de": "Libanon",
    "zh-Hans": "黎巴嫩",
    "hi": "लेबनान",
    "ja": "レバノン",
    "ru": "Ливан",
    "id": "Lebanon",
    "bn": "লেবানন"
  },
  "LC": {
    "en": "St. Lucia",
    "tr": "Saint Lucia",
    "es": "Santa Lucía",
    "pt-BR": "Santa Lúcia",
    "fr": "Sainte-Lucie",
    "de": "St. Lucia",
    "zh-Hans": "圣卢西亚",
    "hi": "सेंट लूसिया",
    "ja": "セントルシア",
    "ru": "Сент-Люсия",
    "id": "Saint Lucia",
    "bn": "সেন্ট লুসিয়া"
  },
  "LI": {
    "en": "Liechtenstein",
    "tr": "Liechtenstein",
    "es": "Liechtenstein",
    "pt-BR": "Liechtenstein",
    "fr": "Liechtenstein",
    "de": "Liechtenstein",
    "zh-Hans": "列支敦士登",
    "hi": "लिचेंस्टीन",
    "ja": "リヒテンシュタイン",
    "ru": "Лихтенштейн",
    "id": "Liechtenstein",
    "bn": "লিচেনস্টেইন"
  },
  "LK": {
    "en": "Sri Lanka",
    "tr": "Sri Lanka",
    "es": "Sri Lanka",
    "pt-BR": "Sri Lanka",
    "fr": "Sri Lanka",
    "de": "Sri Lanka",
    "zh-Hans": "斯里兰卡",
    "hi": "श्रीलंका",
    "ja": "スリランカ",
    "ru": "Шри-Ланка",
    "id": "Sri Lanka",
    "bn": "শ্রীলঙ্কা"
  },
  "LR": {
    "en": "Liberia",
    "tr": "Liberya",
    "es": "Liberia",
    "pt-BR": "Libéria",
    "fr": "Liberia",
    "de": "Liberia",
    "zh-Hans": "利比里亚",
    "hi": "लाइबेरिया",
    "ja": "リベリア",
    "ru": "Либерия",
    "id": "Liberia",
    "bn": "লাইবেরিয়া"
  },
  "LS": {
    "en": "Lesotho",
    "tr": "Lesotho",
    "es": "Lesoto",
    "pt-BR": "Lesoto",
    "fr": "Lesotho",
    "de": "Lesotho",
    "zh-Hans": "莱索托",
    "hi": "लेसोथो",
    "ja": "レソト",
    "ru": "Лесото",
    "id": "Lesotho",
    "bn": "লেসোথো"
  },
  "LT": {
    "en": "Lithuania",
    "tr": "Litvanya",
    "es": "Lituania",
    "pt-BR": "Lituânia",
    "fr": "Lituanie",
    "de": "Litauen",
    "zh-Hans": "立陶宛",
    "hi": "लिथुआनिया",
    "ja": "リトアニア",
    "ru": "Литва",
    "id": "Lituania",
    "bn": "লিথুয়ানিয়া"
  },
  "LU": {
    "en": "Luxembourg",
    "tr": "Lüksemburg",
    "es": "Luxemburgo",
    "pt-BR": "Luxemburgo",
    "fr": "Luxembourg",
    "de": "Luxemburg",
    "zh-Hans": "卢森堡",
    "hi": "लग्ज़मबर्ग",
    "ja": "ルクセンブルク",
    "ru": "Люксембург",
    "id": "Luksemburg",
    "bn": "লাক্সেমবার্গ"
  },
  "LV": {
    "en": "Latvia",
    "tr": "Letonya",
    "es": "Letonia",
    "pt-BR": "Letônia",
    "fr": "Lettonie",
    "de": "Lettland",
    "zh-Hans": "拉脱维亚",
    "hi": "लातविया",
    "ja": "ラトビア",
    "ru": "Латвия",
    "id": "Latvia",
    "bn": "লাটভিয়া"
  },
  "LY": {
    "en": "Libya",
    "tr": "Libya",
    "es": "Libia",
    "pt-BR": "Líbia",
    "fr": "Libye",
    "de": "Libyen",
    "zh-Hans": "利比亚",
    "hi": "लीबिया",
    "ja": "リビア",
    "ru": "Ливия",
    "id": "Libya",
    "bn": "লিবিয়া"
  },
  "MA": {
    "en": "Morocco",
    "tr": "Fas",
    "es": "Marruecos",
    "pt-BR": "Marrocos",
    "fr": "Maroc",
    "de": "Marokko",
    "zh-Hans": "摩洛哥",
    "hi": "मोरक्को",
    "ja": "モロッコ",
    "ru": "Марокко",
    "id": "Maroko",
    "bn": "মরক্কো"
  },
  "MC": {
    "en": "Monaco",
    "tr": "Monako",
    "es": "Mónaco",
    "pt-BR": "Mônaco",
    "fr": "Monaco",
    "de": "Monaco",
    "zh-Hans": "摩纳哥",
    "hi": "मोनाको",
    "ja": "モナコ",
    "ru": "Монако",
    "id": "Monako",
    "bn": "মোনাকো"
  },
  "MD": {
    "en": "Moldova",
    "tr": "Moldova",
    "es": "Moldavia",
    "pt-BR": "Moldávia",
    "fr": "Moldavie",
    "de": "Republik Moldau",
    "zh-Hans": "摩尔多瓦",
    "hi": "मॉल्डोवा",
    "ja": "モルドバ",
    "ru": "Молдова",
    "id": "Moldova",
    "bn": "মলডোভা"
  },
  "ME": {
    "en": "Montenegro",
    "tr": "Karadağ",
    "es": "Montenegro",
    "pt-BR": "Montenegro",
    "fr": "Monténégro",
    "de": "Montenegro",
    "zh-Hans": "黑山",
    "hi": "मोंटेनेग्रो",
    "ja": "モンテネグロ",
    "ru": "Черногория",
    "id": "Montenegro",
    "bn": "মন্টিনিগ্রো"
  },
  "MF": {
    "en": "St. Martin",
    "tr": "Saint Martin",
    "es": "San Martín",
    "pt-BR": "São Martinho",
    "fr": "Saint-Martin",
    "de": "St. Martin",
    "zh-Hans": "法属圣马丁",
    "hi": "सेंट मार्टिन",
    "ja": "サン・マルタン",
    "ru": "Сен-Мартен",
    "id": "Saint Martin",
    "bn": "সেন্ট মার্টিন"
  },
  "MG": {
    "en": "Madagascar",
    "tr": "Madagaskar",
    "es": "Madagascar",
    "pt-BR": "Madagascar",
    "fr": "Madagascar",
    "de": "Madagaskar",
    "zh-Hans": "马达加斯加",
    "hi": "मेडागास्कर",
    "ja": "マダガスカル",
    "ru": "Мадагаскар",
    "id": "Madagaskar",
    "bn": "মাদাগাস্কার"
  },
  "MH": {
    "en": "Marshall Islands",
    "tr": "Marshall Adaları",
    "es": "Islas Marshall",
    "pt-BR": "Ilhas Marshall",
    "fr": "Îles Marshall",
    "de": "Marshallinseln",
    "zh-Hans": "马绍尔群岛",
    "hi": "मार्शल द्वीपसमूह",
    "ja": "マーシャル諸島",
    "ru": "Маршалловы о-ва",
    "id": "Kepulauan Marshall",
    "bn": "মার্শাল দ্বীপপুঞ্জ"
  },
  "MK": {
    "en": "North Macedonia",
    "tr": "Kuzey Makedonya",
    "es": "Macedonia del Norte",
    "pt-BR": "Macedônia do Norte",
    "fr": "Macédoine du Nord",
    "de": "Nordmazedonien",
    "zh-Hans": "北马其顿",
    "hi": "उत्तरी मकदूनिया",
    "ja": "北マケドニア",
    "ru": "Северная Македония",
    "id": "Makedonia Utara",
    "bn": "উত্তর ম্যাসেডোনিয়া"
  },
  "ML": {
    "en": "Mali",
    "tr": "Mali",
    "es": "Mali",
    "pt-BR": "Mali",
    "fr": "Mali",
    "de": "Mali",
    "zh-Hans": "马里",
    "hi": "माली",
    "ja": "マリ",
    "ru": "Мали",
    "id": "Mali",
    "bn": "মালি"
  },
  "MM": {
    "en": "Myanmar (Burma)",
    "tr": "Myanmar (Burma)",
    "es": "Myanmar (Birmania)",
    "pt-BR": "Mianmar (Birmânia)",
    "fr": "Myanmar (Birmanie)",
    "de": "Myanmar",
    "zh-Hans": "缅甸",
    "hi": "म्यांमार (बर्मा)",
    "ja": "ミャンマー (ビルマ)",
    "ru": "Мьянма (Бирма)",
    "id": "Myanmar (Burma)",
    "bn": "মায়ানমার (বার্মা)"
  },
  "MN": {
    "en": "Mongolia",
    "tr": "Moğolistan",
    "es": "Mongolia",
    "pt-BR": "Mongólia",
    "fr": "Mongolie",
    "de": "Mongolei",
    "zh-Hans": "蒙古",
    "hi": "मंगोलिया",
    "ja": "モンゴル",
    "ru": "Монголия",
    "id": "Mongolia",
    "bn": "মঙ্গোলিয়া"
  },
  "MO": {
    "en": "Macao SAR China",
    "tr": "Çin Makao ÖİB",
    "es": "RAE de Macao (China)",
    "pt-BR": "Macau, RAE da China",
    "fr": "R.A.S. chinoise de Macao",
    "de": "Sonderverwaltungsregion Macau",
    "zh-Hans": "中国澳门特别行政区",
    "hi": "मकाऊ (विशेष प्रशासनिक क्षेत्र चीन)",
    "ja": "中華人民共和国マカオ特別行政区",
    "ru": "Макао (САР)",
    "id": "Makau DAK Tiongkok",
    "bn": "ম্যাকাও এসএআর চীন"
  },
  "MP": {
    "en": "Northern Mariana Islands",
    "tr": "Kuzey Mariana Adaları",
    "es": "Islas Marianas del Norte",
    "pt-BR": "Ilhas Marianas do Norte",
    "fr": "Îles Mariannes du Nord",
    "de": "Nördliche Marianen",
    "zh-Hans": "北马里亚纳群岛",
    "hi": "उत्तरी मारियाना द्वीपसमूह",
    "ja": "北マリアナ諸島",
    "ru": "Северные Марианские о-ва",
    "id": "Kepulauan Mariana Utara",
    "bn": "উত্তরাঞ্চলীয় মারিয়ানা দ্বীপপুঞ্জ"
  },
  "MQ": {
    "en": "Martinique",
    "tr": "Martinik",
    "es": "Martinica",
    "pt-BR": "Martinica",
    "fr": "Martinique",
    "de": "Martinique",
    "zh-Hans": "马提尼克",
    "hi": "मार्टीनिक",
    "ja": "マルティニーク",
    "ru": "Мартиника",
    "id": "Martinik",
    "bn": "মার্টিনিক"
  },
  "MR": {
    "en": "Mauritania",
    "tr": "Moritanya",
    "es": "Mauritania",
    "pt-BR": "Mauritânia",
    "fr": "Mauritanie",
    "de": "Mauretanien",
    "zh-Hans": "毛里塔尼亚",
    "hi": "मॉरिटानिया",
    "ja": "モーリタニア",
    "ru": "Мавритания",
    "id": "Mauritania",
    "bn": "মরিতানিয়া"
  },
  "MS": {
    "en": "Montserrat",
    "tr": "Montserrat",
    "es": "Montserrat",
    "pt-BR": "Montserrat",
    "fr": "Montserrat",
    "de": "Montserrat",
    "zh-Hans": "蒙特塞拉特",
    "hi": "मोंटसेरात",
    "ja": "モントセラト",
    "ru": "Монтсеррат",
    "id": "Montserrat",
    "bn": "মন্টসেরাট"
  },
  "MT": {
    "en": "Malta",
    "tr": "Malta",
    "es": "Malta",
    "pt-BR": "Malta",
    "fr": "Malte",
    "de": "Malta",
    "zh-Hans": "马耳他",
    "hi": "माल्टा",
    "ja": "マルタ",
    "ru": "Мальта",
    "id": "Malta",
    "bn": "মাল্টা"
  },
  "MU": {
    "en": "Mauritius",
    "tr": "Mauritius",
    "es": "Mauricio",
    "pt-BR": "Maurício",
    "fr": "Maurice",
    "de": "Mauritius",
    "zh-Hans": "毛里求斯",
    "hi": "मॉरीशस",
    "ja": "モーリシャス",
    "ru": "Маврикий",
    "id": "Mauritius",
    "bn": "মরিশাস"
  },
  "MV": {
    "en": "Maldives",
    "tr": "Maldivler",
    "es": "Maldivas",
    "pt-BR": "Maldivas",
    "fr": "Maldives",
    "de": "Malediven",
    "zh-Hans": "马尔代夫",
    "hi": "मालदीव",
    "ja": "モルディブ",
    "ru": "Мальдивы",
    "id": "Maladewa",
    "bn": "মালদ্বীপ"
  },
  "MW": {
    "en": "Malawi",
    "tr": "Malavi",
    "es": "Malaui",
    "pt-BR": "Malaui",
    "fr": "Malawi",
    "de": "Malawi",
    "zh-Hans": "马拉维",
    "hi": "मलावी",
    "ja": "マラウイ",
    "ru": "Малави",
    "id": "Malawi",
    "bn": "মালাউই"
  },
  "MX": {
    "en": "Mexico",
    "tr": "Meksika",
    "es": "México",
    "pt-BR": "México",
    "fr": "Mexique",
    "de": "Mexiko",
    "zh-Hans": "墨西哥",
    "hi": "मैक्सिको",
    "ja": "メキシコ",
    "ru": "Мексика",
    "id": "Meksiko",
    "bn": "মেক্সিকো"
  },
  "MY": {
    "en": "Malaysia",
    "tr": "Malezya",
    "es": "Malasia",
    "pt-BR": "Malásia",
    "fr": "Malaisie",
    "de": "Malaysia",
    "zh-Hans": "马来西亚",
    "hi": "मलेशिया",
    "ja": "マレーシア",
    "ru": "Малайзия",
    "id": "Malaysia",
    "bn": "মালয়েশিয়া"
  },
  "MZ": {
    "en": "Mozambique",
    "tr": "Mozambik",
    "es": "Mozambique",
    "pt-BR": "Moçambique",
    "fr": "Mozambique",
    "de": "Mosambik",
    "zh-Hans": "莫桑比克",
    "hi": "मोज़ांबिक",
    "ja": "モザンビーク",
    "ru": "Мозамбик",
    "id": "Mozambik",
    "bn": "মোজাম্বিক"
  },
  "NA": {
    "en": "Namibia",
    "tr": "Namibya",
    "es": "Namibia",
    "pt-BR": "Namíbia",
    "fr": "Namibie",
    "de": "Namibia",
    "zh-Hans": "纳米比亚",
    "hi": "नामीबिया",
    "ja": "ナミビア",
    "ru": "Намибия",
    "id": "Namibia",
    "bn": "নামিবিয়া"
  },
  "NC": {
    "en": "New Caledonia",
    "tr": "Yeni Kaledonya",
    "es": "Nueva Caledonia",
    "pt-BR": "Nova Caledônia",
    "fr": "Nouvelle-Calédonie",
    "de": "Neukaledonien",
    "zh-Hans": "新喀里多尼亚",
    "hi": "न्यू कैलेडोनिया",
    "ja": "ニューカレドニア",
    "ru": "Новая Каледония",
    "id": "Kaledonia Baru",
    "bn": "নিউ ক্যালেডোনিয়া"
  },
  "NE": {
    "en": "Niger",
    "tr": "Nijer",
    "es": "Níger",
    "pt-BR": "Níger",
    "fr": "Niger",
    "de": "Niger",
    "zh-Hans": "尼日尔",
    "hi": "नाइजर",
    "ja": "ニジェール",
    "ru": "Нигер",
    "id": "Niger",
    "bn": "নাইজার"
  },
  "NF": {
    "en": "Norfolk Island",
    "tr": "Norfolk Adası",
    "es": "Isla Norfolk",
    "pt-BR": "Ilha Norfolk",
    "fr": "Île Norfolk",
    "de": "Norfolkinsel",
    "zh-Hans": "诺福克岛",
    "hi": "नॉरफ़ॉक द्वीप",
    "ja": "ノーフォーク島",
    "ru": "о-в Норфолк",
    "id": "Kepulauan Norfolk",
    "bn": "নরফোক দ্বীপ"
  },
  "NG": {
    "en": "Nigeria",
    "tr": "Nijerya",
    "es": "Nigeria",
    "pt-BR": "Nigéria",
    "fr": "Nigeria",
    "de": "Nigeria",
    "zh-Hans": "尼日利亚",
    "hi": "नाइजीरिया",
    "ja": "ナイジェリア",
    "ru": "Нигерия",
    "id": "Nigeria",
    "bn": "নাইজেরিয়া"
  },
  "NH": {
    "en": "Vanuatu",
    "tr": "Vanuatu",
    "es": "Vanuatu",
    "pt-BR": "Vanuatu",
    "fr": "Vanuatu",
    "de": "Vanuatu",
    "zh-Hans": "瓦努阿图",
    "hi": "वनुआतू",
    "ja": "バヌアツ",
    "ru": "Вануату",
    "id": "Vanuatu",
    "bn": "ভানুয়াটু"
  },
  "NI": {
    "en": "Nicaragua",
    "tr": "Nikaragua",
    "es": "Nicaragua",
    "pt-BR": "Nicarágua",
    "fr": "Nicaragua",
    "de": "Nicaragua",
    "zh-Hans": "尼加拉瓜",
    "hi": "निकारागुआ",
    "ja": "ニカラグア",
    "ru": "Никарагуа",
    "id": "Nikaragua",
    "bn": "নিকারাগুয়া"
  },
  "NL": {
    "en": "Netherlands",
    "tr": "Hollanda",
    "es": "Países Bajos",
    "pt-BR": "Países Baixos",
    "fr": "Pays-Bas",
    "de": "Niederlande",
    "zh-Hans": "荷兰",
    "hi": "नीदरलैंड",
    "ja": "オランダ",
    "ru": "Нидерланды",
    "id": "Belanda",
    "bn": "নেদারল্যান্ডস"
  },
  "NO": {
    "en": "Norway",
    "tr": "Norveç",
    "es": "Noruega",
    "pt-BR": "Noruega",
    "fr": "Norvège",
    "de": "Norwegen",
    "zh-Hans": "挪威",
    "hi": "नॉर्वे",
    "ja": "ノルウェー",
    "ru": "Норвегия",
    "id": "Norwegia",
    "bn": "নরওয়ে"
  },
  "NP": {
    "en": "Nepal",
    "tr": "Nepal",
    "es": "Nepal",
    "pt-BR": "Nepal",
    "fr": "Népal",
    "de": "Nepal",
    "zh-Hans": "尼泊尔",
    "hi": "नेपाल",
    "ja": "ネパール",
    "ru": "Непал",
    "id": "Nepal",
    "bn": "নেপাল"
  },
  "NR": {
    "en": "Nauru",
    "tr": "Nauru",
    "es": "Nauru",
    "pt-BR": "Nauru",
    "fr": "Nauru",
    "de": "Nauru",
    "zh-Hans": "瑙鲁",
    "hi": "नाउरु",
    "ja": "ナウル",
    "ru": "Науру",
    "id": "Nauru",
    "bn": "নাউরু"
  },
  "NU": {
    "en": "Niue",
    "tr": "Niue",
    "es": "Niue",
    "pt-BR": "Niue",
    "fr": "Niue",
    "de": "Niue",
    "zh-Hans": "纽埃",
    "hi": "नीयू",
    "ja": "ニウエ",
    "ru": "Ниуэ",
    "id": "Niue",
    "bn": "নিউয়ে"
  },
  "NZ": {
    "en": "New Zealand",
    "tr": "Yeni Zelanda",
    "es": "Nueva Zelanda",
    "pt-BR": "Nova Zelândia",
    "fr": "Nouvelle-Zélande",
    "de": "Neuseeland",
    "zh-Hans": "新西兰",
    "hi": "न्यूज़ीलैंड",
    "ja": "ニュージーランド",
    "ru": "Новая Зеландия",
    "id": "Selandia Baru",
    "bn": "নিউজিল্যান্ড"
  },
  "OM": {
    "en": "Oman",
    "tr": "Umman",
    "es": "Omán",
    "pt-BR": "Omã",
    "fr": "Oman",
    "de": "Oman",
    "zh-Hans": "阿曼",
    "hi": "ओमान",
    "ja": "オマーン",
    "ru": "Оман",
    "id": "Oman",
    "bn": "ওমান"
  },
  "PA": {
    "en": "Panama",
    "tr": "Panama",
    "es": "Panamá",
    "pt-BR": "Panamá",
    "fr": "Panama",
    "de": "Panama",
    "zh-Hans": "巴拿马",
    "hi": "पनामा",
    "ja": "パナマ",
    "ru": "Панама",
    "id": "Panama",
    "bn": "পানামা"
  },
  "PE": {
    "en": "Peru",
    "tr": "Peru",
    "es": "Perú",
    "pt-BR": "Peru",
    "fr": "Pérou",
    "de": "Peru",
    "zh-Hans": "秘鲁",
    "hi": "पेरू",
    "ja": "ペルー",
    "ru": "Перу",
    "id": "Peru",
    "bn": "পেরু"
  },
  "PF": {
    "en": "French Polynesia",
    "tr": "Fransız Polinezyası",
    "es": "Polinesia Francesa",
    "pt-BR": "Polinésia Francesa",
    "fr": "Polynésie française",
    "de": "Französisch-Polynesien",
    "zh-Hans": "法属波利尼西亚",
    "hi": "फ़्रेंच पोलिनेशिया",
    "ja": "仏領ポリネシア",
    "ru": "Французская Полинезия",
    "id": "Polinesia Prancis",
    "bn": "ফরাসী পলিনেশিয়া"
  },
  "PG": {
    "en": "Papua New Guinea",
    "tr": "Papua Yeni Gine",
    "es": "Papúa Nueva Guinea",
    "pt-BR": "Papua-Nova Guiné",
    "fr": "Papouasie-Nouvelle-Guinée",
    "de": "Papua-Neuguinea",
    "zh-Hans": "巴布亚新几内亚",
    "hi": "पापुआ न्यू गिनी",
    "ja": "パプアニューギニア",
    "ru": "Папуа — Новая Гвинея",
    "id": "Papua Nugini",
    "bn": "পাপুয়া নিউ গিনি"
  },
  "PH": {
    "en": "Philippines",
    "tr": "Filipinler",
    "es": "Filipinas",
    "pt-BR": "Filipinas",
    "fr": "Philippines",
    "de": "Philippinen",
    "zh-Hans": "菲律宾",
    "hi": "फ़िलिपींस",
    "ja": "フィリピン",
    "ru": "Филиппины",
    "id": "Filipina",
    "bn": "ফিলিপাইন"
  },
  "PK": {
    "en": "Pakistan",
    "tr": "Pakistan",
    "es": "Pakistán",
    "pt-BR": "Paquistão",
    "fr": "Pakistan",
    "de": "Pakistan",
    "zh-Hans": "巴基斯坦",
    "hi": "पाकिस्तान",
    "ja": "パキスタン",
    "ru": "Пакистан",
    "id": "Pakistan",
    "bn": "পাকিস্তান"
  },
  "PL": {
    "en": "Poland",
    "tr": "Polonya",
    "es": "Polonia",
    "pt-BR": "Polônia",
    "fr": "Pologne",
    "de": "Polen",
    "zh-Hans": "波兰",
    "hi": "पोलैंड",
    "ja": "ポーランド",
    "ru": "Польша",
    "id": "Polandia",
    "bn": "পোল্যান্ড"
  },
  "PM": {
    "en": "St. Pierre & Miquelon",
    "tr": "Saint Pierre ve Miquelon",
    "es": "San Pedro y Miquelón",
    "pt-BR": "São Pedro e Miquelão",
    "fr": "Saint-Pierre-et-Miquelon",
    "de": "St. Pierre und Miquelon",
    "zh-Hans": "圣皮埃尔和密克隆群岛",
    "hi": "सेंट पिएरे और मिक्वेलान",
    "ja": "サンピエール島・ミクロン島",
    "ru": "Сен-Пьер и Микелон",
    "id": "Saint Pierre dan Miquelon",
    "bn": "সেন্ট পিয়ের ও মিকুয়েলন"
  },
  "PN": {
    "en": "Pitcairn Islands",
    "tr": "Pitcairn Adaları",
    "es": "Islas Pitcairn",
    "pt-BR": "Ilhas Pitcairn",
    "fr": "Îles Pitcairn",
    "de": "Pitcairninseln",
    "zh-Hans": "皮特凯恩群岛",
    "hi": "पिटकैर्न द्वीपसमूह",
    "ja": "ピトケアン諸島",
    "ru": "о-ва Питкэрн",
    "id": "Kepulauan Pitcairn",
    "bn": "পিটকেয়ার্ন দ্বীপপুঞ্জ"
  },
  "PR": {
    "en": "Puerto Rico",
    "tr": "Porto Riko",
    "es": "Puerto Rico",
    "pt-BR": "Porto Rico",
    "fr": "Porto Rico",
    "de": "Puerto Rico",
    "zh-Hans": "波多黎各",
    "hi": "पोर्टो रिको",
    "ja": "プエルトリコ",
    "ru": "Пуэрто-Рико",
    "id": "Puerto Riko",
    "bn": "পুয়ের্তো রিকো"
  },
  "PS": {
    "en": "Palestinian Territories",
    "tr": "Filistin Bölgeleri",
    "es": "Territorios Palestinos",
    "pt-BR": "Territórios palestinos",
    "fr": "Territoires palestiniens",
    "de": "Palästinensische Autonomiegebiete",
    "zh-Hans": "巴勒斯坦领土",
    "hi": "फ़िलिस्तीनी क्षेत्र",
    "ja": "パレスチナ自治区",
    "ru": "Палестинские территории",
    "id": "Wilayah Palestina",
    "bn": "প্যালেস্টাইন ভূখণ্ড"
  },
  "PT": {
    "en": "Portugal",
    "tr": "Portekiz",
    "es": "Portugal",
    "pt-BR": "Portugal",
    "fr": "Portugal",
    "de": "Portugal",
    "zh-Hans": "葡萄牙",
    "hi": "पुर्तगाल",
    "ja": "ポルトガル",
    "ru": "Португалия",
    "id": "Portugal",
    "bn": "পর্তুগাল"
  },
  "PW": {
    "en": "Palau",
    "tr": "Palau",
    "es": "Palaos",
    "pt-BR": "Palau",
    "fr": "Palaos",
    "de": "Palau",
    "zh-Hans": "帕劳",
    "hi": "पलाऊ",
    "ja": "パラオ",
    "ru": "Палау",
    "id": "Palau",
    "bn": "পালাউ"
  },
  "PY": {
    "en": "Paraguay",
    "tr": "Paraguay",
    "es": "Paraguay",
    "pt-BR": "Paraguai",
    "fr": "Paraguay",
    "de": "Paraguay",
    "zh-Hans": "巴拉圭",
    "hi": "पराग्वे",
    "ja": "パラグアイ",
    "ru": "Парагвай",
    "id": "Paraguay",
    "bn": "প্যারাগুয়ে"
  },
  "QA": {
    "en": "Qatar",
    "tr": "Katar",
    "es": "Catar",
    "pt-BR": "Catar",
    "fr": "Qatar",
    "de": "Katar",
    "zh-Hans": "卡塔尔",
    "hi": "क़तर",
    "ja": "カタール",
    "ru": "Катар",
    "id": "Qatar",
    "bn": "কাতার"
  },
  "QO": {
    "en": "Outlying Oceania",
    "tr": "Uzak Okyanusya",
    "es": "Territorios alejados de Oceanía",
    "pt-BR": "Oceania Remota",
    "fr": "régions éloignées de l’Océanie",
    "de": "Äußeres Ozeanien",
    "zh-Hans": "大洋洲边远群岛",
    "hi": "आउटलाइंग ओशिनिया",
    "ja": "オセアニア周辺地域",
    "ru": "Внешняя Океания",
    "id": "Oseania Luar",
    "bn": "আউটলাইনিং ওসানিয়া"
  },
  "RE": {
    "en": "Réunion",
    "tr": "Reunion",
    "es": "Reunión",
    "pt-BR": "Reunião",
    "fr": "La Réunion",
    "de": "Réunion",
    "zh-Hans": "留尼汪",
    "hi": "रियूनियन",
    "ja": "レユニオン",
    "ru": "Реюньон",
    "id": "Réunion",
    "bn": "রিইউনিয়ন"
  },
  "RH": {
    "en": "Zimbabwe",
    "tr": "Zimbabve",
    "es": "Zimbabue",
    "pt-BR": "Zimbábue",
    "fr": "Zimbabwe",
    "de": "Simbabwe",
    "zh-Hans": "津巴布韦",
    "hi": "ज़िम्बाब्वे",
    "ja": "ジンバブエ",
    "ru": "Зимбабве",
    "id": "Zimbabwe",
    "bn": "জিম্বাবোয়ে"
  },
  "RO": {
    "en": "Romania",
    "tr": "Romanya",
    "es": "Rumanía",
    "pt-BR": "Romênia",
    "fr": "Roumanie",
    "de": "Rumänien",
    "zh-Hans": "罗马尼亚",
    "hi": "रोमानिया",
    "ja": "ルーマニア",
    "ru": "Румыния",
    "id": "Rumania",
    "bn": "রোমানিয়া"
  },
  "RS": {
    "en": "Serbia",
    "tr": "Sırbistan",
    "es": "Serbia",
    "pt-BR": "Sérvia",
    "fr": "Serbie",
    "de": "Serbien",
    "zh-Hans": "塞尔维亚",
    "hi": "सर्बिया",
    "ja": "セルビア",
    "ru": "Сербия",
    "id": "Serbia",
    "bn": "সার্বিয়া"
  },
  "RU": {
    "en": "Russia",
    "tr": "Rusya",
    "es": "Rusia",
    "pt-BR": "Rússia",
    "fr": "Russie",
    "de": "Russland",
    "zh-Hans": "俄罗斯",
    "hi": "रूस",
    "ja": "ロシア",
    "ru": "Россия",
    "id": "Rusia",
    "bn": "রাশিয়া"
  },
  "RW": {
    "en": "Rwanda",
    "tr": "Ruanda",
    "es": "Ruanda",
    "pt-BR": "Ruanda",
    "fr": "Rwanda",
    "de": "Ruanda",
    "zh-Hans": "卢旺达",
    "hi": "रवांडा",
    "ja": "ルワンダ",
    "ru": "Руанда",
    "id": "Rwanda",
    "bn": "রুয়ান্ডা"
  },
  "SA": {
    "en": "Saudi Arabia",
    "tr": "Suudi Arabistan",
    "es": "Arabia Saudí",
    "pt-BR": "Arábia Saudita",
    "fr": "Arabie saoudite",
    "de": "Saudi-Arabien",
    "zh-Hans": "沙特阿拉伯",
    "hi": "सऊदी अरब",
    "ja": "サウジアラビア",
    "ru": "Саудовская Аравия",
    "id": "Arab Saudi",
    "bn": "সৌদি আরব"
  },
  "SB": {
    "en": "Solomon Islands",
    "tr": "Solomon Adaları",
    "es": "Islas Salomón",
    "pt-BR": "Ilhas Salomão",
    "fr": "Îles Salomon",
    "de": "Salomonen",
    "zh-Hans": "所罗门群岛",
    "hi": "सोलोमन द्वीपसमूह",
    "ja": "ソロモン諸島",
    "ru": "Соломоновы о-ва",
    "id": "Kepulauan Solomon",
    "bn": "সলোমন দ্বীপপুঞ্জ"
  },
  "SC": {
    "en": "Seychelles",
    "tr": "Seyşeller",
    "es": "Seychelles",
    "pt-BR": "Seicheles",
    "fr": "Seychelles",
    "de": "Seychellen",
    "zh-Hans": "塞舌尔",
    "hi": "सेशेल्स",
    "ja": "セーシェル",
    "ru": "Сейшельские о-ва",
    "id": "Seychelles",
    "bn": "সিসিলি"
  },
  "SD": {
    "en": "Sudan",
    "tr": "Sudan",
    "es": "Sudán",
    "pt-BR": "Sudão",
    "fr": "Soudan",
    "de": "Sudan",
    "zh-Hans": "苏丹",
    "hi": "सूडान",
    "ja": "スーダン",
    "ru": "Судан",
    "id": "Sudan",
    "bn": "সুদান"
  },
  "SE": {
    "en": "Sweden",
    "tr": "İsveç",
    "es": "Suecia",
    "pt-BR": "Suécia",
    "fr": "Suède",
    "de": "Schweden",
    "zh-Hans": "瑞典",
    "hi": "स्वीडन",
    "ja": "スウェーデン",
    "ru": "Швеция",
    "id": "Swedia",
    "bn": "সুইডেন"
  },
  "SG": {
    "en": "Singapore",
    "tr": "Singapur",
    "es": "Singapur",
    "pt-BR": "Singapura",
    "fr": "Singapour",
    "de": "Singapur",
    "zh-Hans": "新加坡",
    "hi": "सिंगापुर",
    "ja": "シンガポール",
    "ru": "Сингапур",
    "id": "Singapura",
    "bn": "সিঙ্গাপুর"
  },
  "SH": {
    "en": "St. Helena",
    "tr": "Saint Helena",
    "es": "Santa Elena",
    "pt-BR": "Santa Helena",
    "fr": "Sainte-Hélène",
    "de": "St. Helena",
    "zh-Hans": "圣赫勒拿",
    "hi": "सेंट हेलेना",
    "ja": "セントヘレナ",
    "ru": "о-в Св. Елены",
    "id": "Saint Helena",
    "bn": "সেন্ট হেলেনা"
  },
  "SI": {
    "en": "Slovenia",
    "tr": "Slovenya",
    "es": "Eslovenia",
    "pt-BR": "Eslovênia",
    "fr": "Slovénie",
    "de": "Slowenien",
    "zh-Hans": "斯洛文尼亚",
    "hi": "स्लोवेनिया",
    "ja": "スロベニア",
    "ru": "Словения",
    "id": "Slovenia",
    "bn": "স্লোভানিয়া"
  },
  "SJ": {
    "en": "Svalbard & Jan Mayen",
    "tr": "Svalbard ve Jan Mayen",
    "es": "Svalbard y Jan Mayen",
    "pt-BR": "Svalbard e Jan Mayen",
    "fr": "Svalbard et Jan Mayen",
    "de": "Spitzbergen und Jan Mayen",
    "zh-Hans": "斯瓦尔巴和扬马延",
    "hi": "स्वालबार्ड और जान मायेन",
    "ja": "スバールバル諸島・ヤンマイエン島",
    "ru": "Шпицберген и Ян-Майен",
    "id": "Kepulauan Svalbard dan Jan Mayen",
    "bn": "স্বালবার্ড ও জান মেয়েন"
  },
  "SK": {
    "en": "Slovakia",
    "tr": "Slovakya",
    "es": "Eslovaquia",
    "pt-BR": "Eslováquia",
    "fr": "Slovaquie",
    "de": "Slowakei",
    "zh-Hans": "斯洛伐克",
    "hi": "स्लोवाकिया",
    "ja": "スロバキア",
    "ru": "Словакия",
    "id": "Slovakia",
    "bn": "স্লোভাকিয়া"
  },
  "SL": {
    "en": "Sierra Leone",
    "tr": "Sierra Leone",
    "es": "Sierra Leona",
    "pt-BR": "Serra Leoa",
    "fr": "Sierra Leone",
    "de": "Sierra Leone",
    "zh-Hans": "塞拉利昂",
    "hi": "सिएरा लियोन",
    "ja": "シエラレオネ",
    "ru": "Сьерра-Леоне",
    "id": "Sierra Leone",
    "bn": "সিয়েরা লিওন"
  },
  "SM": {
    "en": "San Marino",
    "tr": "San Marino",
    "es": "San Marino",
    "pt-BR": "San Marino",
    "fr": "Saint-Marin",
    "de": "San Marino",
    "zh-Hans": "圣马力诺",
    "hi": "सैन मेरीनो",
    "ja": "サンマリノ",
    "ru": "Сан-Марино",
    "id": "San Marino",
    "bn": "সান মারিনো"
  },
  "SN": {
    "en": "Senegal",
    "tr": "Senegal",
    "es": "Senegal",
    "pt-BR": "Senegal",
    "fr": "Sénégal",
    "de": "Senegal",
    "zh-Hans": "塞内加尔",
    "hi": "सेनेगल",
    "ja": "セネガル",
    "ru": "Сенегал",
    "id": "Senegal",
    "bn": "সেনেগাল"
  },
  "SO": {
    "en": "Somalia",
    "tr": "Somali",
    "es": "Somalia",
    "pt-BR": "Somália",
    "fr": "Somalie",
    "de": "Somalia",
    "zh-Hans": "索马里",
    "hi": "सोमालिया",
    "ja": "ソマリア",
    "ru": "Сомали",
    "id": "Somalia",
    "bn": "সোমালিয়া"
  },
  "SR": {
    "en": "Suriname",
    "tr": "Surinam",
    "es": "Surinam",
    "pt-BR": "Suriname",
    "fr": "Suriname",
    "de": "Suriname",
    "zh-Hans": "苏里南",
    "hi": "सूरीनाम",
    "ja": "スリナム",
    "ru": "Суринам",
    "id": "Suriname",
    "bn": "সুরিনাম"
  },
  "SS": {
    "en": "South Sudan",
    "tr": "Güney Sudan",
    "es": "Sudán del Sur",
    "pt-BR": "Sudão do Sul",
    "fr": "Soudan du Sud",
    "de": "Südsudan",
    "zh-Hans": "南苏丹",
    "hi": "दक्षिण सूडान",
    "ja": "南スーダン",
    "ru": "Южный Судан",
    "id": "Sudan Selatan",
    "bn": "দক্ষিণ সুদান"
  },
  "ST": {
    "en": "São Tomé & Príncipe",
    "tr": "Sao Tome ve Principe",
    "es": "Santo Tomé y Príncipe",
    "pt-BR": "São Tomé e Príncipe",
    "fr": "Sao Tomé-et-Principe",
    "de": "São Tomé und Príncipe",
    "zh-Hans": "圣多美和普林西比",
    "hi": "साओ टोम और प्रिंसिपे",
    "ja": "サントメ・プリンシペ",
    "ru": "Сан-Томе и Принсипи",
    "id": "Sao Tome dan Principe",
    "bn": "সাওটোমা ও প্রিন্সিপি"
  },
  "SU": {
    "en": "Russia",
    "tr": "Rusya",
    "es": "Rusia",
    "pt-BR": "Rússia",
    "fr": "Russie",
    "de": "Russland",
    "zh-Hans": "俄罗斯",
    "hi": "रूस",
    "ja": "ロシア",
    "ru": "Россия",
    "id": "Rusia",
    "bn": "রাশিয়া"
  },
  "SV": {
    "en": "El Salvador",
    "tr": "El Salvador",
    "es": "El Salvador",
    "pt-BR": "El Salvador",
    "fr": "Salvador",
    "de": "El Salvador",
    "zh-Hans": "萨尔瓦多",
    "hi": "अल सल्वाडोर",
    "ja": "エルサルバドル",
    "ru": "Сальвадор",
    "id": "El Salvador",
    "bn": "এল সালভেদর"
  },
  "SX": {
    "en": "Sint Maarten",
    "tr": "Sint Maarten",
    "es": "Sint Maarten",
    "pt-BR": "Sint Maarten",
    "fr": "Saint-Martin (partie néerlandaise)",
    "de": "Sint Maarten",
    "zh-Hans": "荷属圣马丁",
    "hi": "सिंट मार्टिन",
    "ja": "シント・マールテン",
    "ru": "Синт-Мартен",
    "id": "Sint Maarten",
    "bn": "সিন্ট মার্টেন"
  },
  "SY": {
    "en": "Syria",
    "tr": "Suriye",
    "es": "Siria",
    "pt-BR": "Síria",
    "fr": "Syrie",
    "de": "Syrien",
    "zh-Hans": "叙利亚",
    "hi": "सीरिया",
    "ja": "シリア",
    "ru": "Сирия",
    "id": "Suriah",
    "bn": "সিরিয়া"
  },
  "SZ": {
    "en": "Eswatini",
    "tr": "Esvatini",
    "es": "Esuatini",
    "pt-BR": "Essuatíni",
    "fr": "Eswatini",
    "de": "Eswatini",
    "zh-Hans": "斯威士兰",
    "hi": "एस्वाटिनी",
    "ja": "エスワティニ",
    "ru": "Эсватини",
    "id": "eSwatini",
    "bn": "ইসওয়াতিনি"
  },
  "TA": {
    "en": "Tristan da Cunha",
    "tr": "Tristan da Cunha",
    "es": "Tristán de Acuña",
    "pt-BR": "Tristão da Cunha",
    "fr": "Tristan da Cunha",
    "de": "Tristan da Cunha",
    "zh-Hans": "特里斯坦-达库尼亚群岛",
    "hi": "ट्रिस्टन दा कुना",
    "ja": "トリスタン・ダ・クーニャ",
    "ru": "Тристан-да-Кунья",
    "id": "Tristan da Cunha",
    "bn": "ট্রিস্টান ডা কুনহা"
  },
  "TC": {
    "en": "Turks & Caicos Islands",
    "tr": "Turks ve Caicos Adaları",
    "es": "Islas Turcas y Caicos",
    "pt-BR": "Ilhas Turcas e Caicos",
    "fr": "Îles Turques-et-Caïques",
    "de": "Turks- und Caicosinseln",
    "zh-Hans": "特克斯和凯科斯群岛",
    "hi": "तुर्क और कैकोज़ द्वीपसमूह",
    "ja": "タークス・カイコス諸島",
    "ru": "Тёркс и Кайкос",
    "id": "Kepulauan Turks dan Caicos",
    "bn": "তুর্কস ও কাইকোস দ্বীপপুঞ্জ"
  },
  "TD": {
    "en": "Chad",
    "tr": "Çad",
    "es": "Chad",
    "pt-BR": "Chade",
    "fr": "Tchad",
    "de": "Tschad",
    "zh-Hans": "乍得",
    "hi": "चाड",
    "ja": "チャド",
    "ru": "Чад",
    "id": "Chad",
    "bn": "চাদ"
  },
  "TF": {
    "en": "French Southern Territories",
    "tr": "Fransız Güney Toprakları",
    "es": "Territorios Australes Franceses",
    "pt-BR": "Territórios Franceses do Sul",
    "fr": "Terres australes françaises",
    "de": "Französische Süd- und Antarktisgebiete",
    "zh-Hans": "法属南部领地",
    "hi": "फ़्रांसीसी दक्षिणी क्षेत्र",
    "ja": "仏領極南諸島",
    "ru": "Французские Южные территории",
    "id": "Wilayah Selatan Prancis",
    "bn": "ফরাসী দক্ষিণাঞ্চল"
  },
  "TG": {
    "en": "Togo",
    "tr": "Togo",
    "es": "Togo",
    "pt-BR": "Togo",
    "fr": "Togo",
    "de": "Togo",
    "zh-Hans": "多哥",
    "hi": "टोगो",
    "ja": "トーゴ",
    "ru": "Того",
    "id": "Togo",
    "bn": "টোগো"
  },
  "TH": {
    "en": "Thailand",
    "tr": "Tayland",
    "es": "Tailandia",
    "pt-BR": "Tailândia",
    "fr": "Thaïlande",
    "de": "Thailand",
    "zh-Hans": "泰国",
    "hi": "थाईलैंड",
    "ja": "タイ",
    "ru": "Таиланд",
    "id": "Thailand",
    "bn": "থাইল্যান্ড"
  },
  "TJ": {
    "en": "Tajikistan",
    "tr": "Tacikistan",
    "es": "Tayikistán",
    "pt-BR": "Tadjiquistão",
    "fr": "Tadjikistan",
    "de": "Tadschikistan",
    "zh-Hans": "塔吉克斯坦",
    "hi": "ताजिकिस्तान",
    "ja": "タジキスタン",
    "ru": "Таджикистан",
    "id": "Tajikistan",
    "bn": "তাজিকিস্তান"
  },
  "TK": {
    "en": "Tokelau",
    "tr": "Tokelau",
    "es": "Tokelau",
    "pt-BR": "Tokelau",
    "fr": "Tokelau",
    "de": "Tokelau",
    "zh-Hans": "托克劳",
    "hi": "तोकेलाउ",
    "ja": "トケラウ",
    "ru": "Токелау",
    "id": "Tokelau",
    "bn": "টোকেলাউ"
  },
  "TL": {
    "en": "Timor-Leste",
    "tr": "Timor-Leste",
    "es": "Timor-Leste",
    "pt-BR": "Timor-Leste",
    "fr": "Timor oriental",
    "de": "Timor-Leste",
    "zh-Hans": "东帝汶",
    "hi": "तिमोर-लेस्त",
    "ja": "東ティモール",
    "ru": "Восточный Тимор",
    "id": "Timor Leste",
    "bn": "তিমুর-লেস্তে"
  },
  "TM": {
    "en": "Turkmenistan",
    "tr": "Türkmenistan",
    "es": "Turkmenistán",
    "pt-BR": "Turcomenistão",
    "fr": "Turkménistan",
    "de": "Turkmenistan",
    "zh-Hans": "土库曼斯坦",
    "hi": "तुर्कमेनिस्तान",
    "ja": "トルクメニスタン",
    "ru": "Туркменистан",
    "id": "Turkmenistan",
    "bn": "তুর্কমেনিস্তান"
  },
  "TN": {
    "en": "Tunisia",
    "tr": "Tunus",
    "es": "Túnez",
    "pt-BR": "Tunísia",
    "fr": "Tunisie",
    "de": "Tunesien",
    "zh-Hans": "突尼斯",
    "hi": "ट्यूनीशिया",
    "ja": "チュニジア",
    "ru": "Тунис",
    "id": "Tunisia",
    "bn": "তিউনিসিয়া"
  },
  "TO": {
    "en": "Tonga",
    "tr": "Tonga",
    "es": "Tonga",
    "pt-BR": "Tonga",
    "fr": "Tonga",
    "de": "Tonga",
    "zh-Hans": "汤加",
    "hi": "टोंगा",
    "ja": "トンガ",
    "ru": "Тонга",
    "id": "Tonga",
    "bn": "টোঙ্গা"
  },
  "TP": {
    "en": "Timor-Leste",
    "tr": "Timor-Leste",
    "es": "Timor-Leste",
    "pt-BR": "Timor-Leste",
    "fr": "Timor oriental",
    "de": "Timor-Leste",
    "zh-Hans": "东帝汶",
    "hi": "तिमोर-लेस्त",
    "ja": "東ティモール",
    "ru": "Восточный Тимор",
    "id": "Timor Leste",
    "bn": "তিমুর-লেস্তে"
  },
  "TR": {
    "en": "Türkiye",
    "tr": "Türkiye",
    "es": "Turquía",
    "pt-BR": "Turquia",
    "fr": "Turquie",
    "de": "Türkei",
    "zh-Hans": "土耳其",
    "hi": "तुर्किये",
    "ja": "トルコ",
    "ru": "Турция",
    "id": "Turki",
    "bn": "তুরস্ক"
  },
  "TT": {
    "en": "Trinidad & Tobago",
    "tr": "Trinidad ve Tobago",
    "es": "Trinidad y Tobago",
    "pt-BR": "Trinidad e Tobago",
    "fr": "Trinité-et-Tobago",
    "de": "Trinidad und Tobago",
    "zh-Hans": "特立尼达和多巴哥",
    "hi": "त्रिनिदाद और टोबैगो",
    "ja": "トリニダード・トバゴ",
    "ru": "Тринидад и Тобаго",
    "id": "Trinidad dan Tobago",
    "bn": "ত্রিনিদাদ ও টোবাগো"
  },
  "TV": {
    "en": "Tuvalu",
    "tr": "Tuvalu",
    "es": "Tuvalu",
    "pt-BR": "Tuvalu",
    "fr": "Tuvalu",
    "de": "Tuvalu",
    "zh-Hans": "图瓦卢",
    "hi": "तुवालू",
    "ja": "ツバル",
    "ru": "Тувалу",
    "id": "Tuvalu",
    "bn": "টুভালু"
  },
  "TW": {
    "en": "Taiwan",
    "tr": "Tayvan",
    "es": "Taiwán",
    "pt-BR": "Taiwan",
    "fr": "Taïwan",
    "de": "Taiwan",
    "zh-Hans": "台湾",
    "hi": "ताइवान",
    "ja": "台湾",
    "ru": "Тайвань",
    "id": "Taiwan",
    "bn": "তাইওয়ান"
  },
  "TZ": {
    "en": "Tanzania",
    "tr": "Tanzanya",
    "es": "Tanzania",
    "pt-BR": "Tanzânia",
    "fr": "Tanzanie",
    "de": "Tansania",
    "zh-Hans": "坦桑尼亚",
    "hi": "तंज़ानिया",
    "ja": "タンザニア",
    "ru": "Танзания",
    "id": "Tanzania",
    "bn": "তাঞ্জানিয়া"
  },
  "UA": {
    "en": "Ukraine",
    "tr": "Ukrayna",
    "es": "Ucrania",
    "pt-BR": "Ucrânia",
    "fr": "Ukraine",
    "de": "Ukraine",
    "zh-Hans": "乌克兰",
    "hi": "यूक्रेन",
    "ja": "ウクライナ",
    "ru": "Украина",
    "id": "Ukraina",
    "bn": "ইউক্রেন"
  },
  "UG": {
    "en": "Uganda",
    "tr": "Uganda",
    "es": "Uganda",
    "pt-BR": "Uganda",
    "fr": "Ouganda",
    "de": "Uganda",
    "zh-Hans": "乌干达",
    "hi": "युगांडा",
    "ja": "ウガンダ",
    "ru": "Уганда",
    "id": "Uganda",
    "bn": "উগান্ডা"
  },
  "UK": {
    "en": "United Kingdom",
    "tr": "Birleşik Krallık",
    "es": "Reino Unido",
    "pt-BR": "Reino Unido",
    "fr": "Royaume-Uni",
    "de": "Vereinigtes Königreich",
    "zh-Hans": "英国",
    "hi": "यूनाइटेड किंगडम",
    "ja": "イギリス",
    "ru": "Великобритания",
    "id": "Inggris Raya",
    "bn": "যুক্তরাজ্য"
  },
  "UM": {
    "en": "U.S. Outlying Islands",
    "tr": "ABD Küçük Harici Adaları",
    "es": "Islas menores alejadas de EE. UU.",
    "pt-BR": "Ilhas Menores Distantes dos EUA",
    "fr": "Îles mineures éloignées des États-Unis",
    "de": "Amerikanische Überseeinseln",
    "zh-Hans": "美国本土外小岛屿",
    "hi": "यू॰एस॰ आउटलाइंग द्वीपसमूह",
    "ja": "合衆国領有小離島",
    "ru": "Внешние малые о-ва (США)",
    "id": "Kepulauan Terluar AS",
    "bn": "যুক্তরাষ্ট্রের পার্শ্ববর্তী দ্বীপপুঞ্জ"
  },
  "UN": {
    "en": "United Nations",
    "tr": "Birleşmiş Milletler",
    "es": "Naciones Unidas",
    "pt-BR": "Nações Unidas",
    "fr": "Nations Unies",
    "de": "Vereinte Nationen",
    "zh-Hans": "联合国",
    "hi": "संयुक्त राष्ट्र",
    "ja": "国際連合",
    "ru": "Организация Объединенных Наций",
    "id": "Perserikatan Bangsa-Bangsa",
    "bn": "জাতিসংঘ"
  },
  "US": {
    "en": "United States",
    "tr": "Amerika Birleşik Devletleri",
    "es": "Estados Unidos",
    "pt-BR": "Estados Unidos",
    "fr": "États-Unis",
    "de": "Vereinigte Staaten",
    "zh-Hans": "美国",
    "hi": "संयुक्त राज्य",
    "ja": "アメリカ合衆国",
    "ru": "Соединенные Штаты",
    "id": "Amerika Serikat",
    "bn": "মার্কিন যুক্তরাষ্ট্র"
  },
  "UY": {
    "en": "Uruguay",
    "tr": "Uruguay",
    "es": "Uruguay",
    "pt-BR": "Uruguai",
    "fr": "Uruguay",
    "de": "Uruguay",
    "zh-Hans": "乌拉圭",
    "hi": "उरूग्वे",
    "ja": "ウルグアイ",
    "ru": "Уругвай",
    "id": "Uruguay",
    "bn": "উরুগুয়ে"
  },
  "UZ": {
    "en": "Uzbekistan",
    "tr": "Özbekistan",
    "es": "Uzbekistán",
    "pt-BR": "Uzbequistão",
    "fr": "Ouzbékistan",
    "de": "Usbekistan",
    "zh-Hans": "乌兹别克斯坦",
    "hi": "उज़्बेकिस्तान",
    "ja": "ウズベキスタン",
    "ru": "Узбекистан",
    "id": "Uzbekistan",
    "bn": "উজবেকিস্তান"
  },
  "VA": {
    "en": "Vatican City",
    "tr": "Vatikan",
    "es": "Ciudad del Vaticano",
    "pt-BR": "Cidade do Vaticano",
    "fr": "État de la Cité du Vatican",
    "de": "Vatikanstadt",
    "zh-Hans": "梵蒂冈",
    "hi": "वेटिकन सिटी",
    "ja": "バチカン市国",
    "ru": "Ватикан",
    "id": "Vatikan",
    "bn": "ভ্যাটিকান সিটি"
  },
  "VC": {
    "en": "St. Vincent & Grenadines",
    "tr": "Saint Vincent ve Grenadinler",
    "es": "San Vicente y las Granadinas",
    "pt-BR": "São Vicente e Granadinas",
    "fr": "Saint-Vincent-et-les Grenadines",
    "de": "St. Vincent und die Grenadinen",
    "zh-Hans": "圣文森特和格林纳丁斯",
    "hi": "सेंट विंसेंट और ग्रेनाडाइंस",
    "ja": "セントビンセント及びグレナディーン諸島",
    "ru": "Сент-Винсент и Гренадины",
    "id": "Saint Vincent dan Grenadine",
    "bn": "সেন্ট ভিনসেন্ট ও গ্রেনাডিনস"
  },
  "VD": {
    "en": "Vietnam",
    "tr": "Vietnam",
    "es": "Vietnam",
    "pt-BR": "Vietnã",
    "fr": "Viêt Nam",
    "de": "Vietnam",
    "zh-Hans": "越南",
    "hi": "वियतनाम",
    "ja": "ベトナム",
    "ru": "Вьетнам",
    "id": "Vietnam",
    "bn": "ভিয়েতনাম"
  },
  "VE": {
    "en": "Venezuela",
    "tr": "Venezuela",
    "es": "Venezuela",
    "pt-BR": "Venezuela",
    "fr": "Venezuela",
    "de": "Venezuela",
    "zh-Hans": "委内瑞拉",
    "hi": "वेनेज़ुएला",
    "ja": "ベネズエラ",
    "ru": "Венесуэла",
    "id": "Venezuela",
    "bn": "ভেনেজুয়েলা"
  },
  "VG": {
    "en": "British Virgin Islands",
    "tr": "Britanya Virjin Adaları",
    "es": "Islas Vírgenes Británicas",
    "pt-BR": "Ilhas Virgens Britânicas",
    "fr": "Îles Vierges britanniques",
    "de": "Britische Jungferninseln",
    "zh-Hans": "英属维尔京群岛",
    "hi": "ब्रिटिश वर्जिन द्वीपसमूह",
    "ja": "英領ヴァージン諸島",
    "ru": "Виргинские о-ва (Великобритания)",
    "id": "Kepulauan Virgin Britania Raya",
    "bn": "ব্রিটিশ ভার্জিন দ্বীপপুঞ্জ"
  },
  "VI": {
    "en": "U.S. Virgin Islands",
    "tr": "ABD Virjin Adaları",
    "es": "Islas Vírgenes de EE. UU.",
    "pt-BR": "Ilhas Virgens Americanas",
    "fr": "Îles Vierges des États-Unis",
    "de": "Amerikanische Jungferninseln",
    "zh-Hans": "美属维尔京群岛",
    "hi": "यू॰एस॰ वर्जिन द्वीपसमूह",
    "ja": "米領ヴァージン諸島",
    "ru": "Виргинские о-ва (США)",
    "id": "Kepulauan Virgin Amerika Serikat",
    "bn": "মার্কিন যুক্তরাষ্ট্রীয় ভার্জিন দ্বীপপুঞ্জ"
  },
  "VN": {
    "en": "Vietnam",
    "tr": "Vietnam",
    "es": "Vietnam",
    "pt-BR": "Vietnã",
    "fr": "Viêt Nam",
    "de": "Vietnam",
    "zh-Hans": "越南",
    "hi": "वियतनाम",
    "ja": "ベトナム",
    "ru": "Вьетнам",
    "id": "Vietnam",
    "bn": "ভিয়েতনাম"
  },
  "VU": {
    "en": "Vanuatu",
    "tr": "Vanuatu",
    "es": "Vanuatu",
    "pt-BR": "Vanuatu",
    "fr": "Vanuatu",
    "de": "Vanuatu",
    "zh-Hans": "瓦努阿图",
    "hi": "वनुआतू",
    "ja": "バヌアツ",
    "ru": "Вануату",
    "id": "Vanuatu",
    "bn": "ভানুয়াটু"
  },
  "WF": {
    "en": "Wallis & Futuna",
    "tr": "Wallis ve Futuna",
    "es": "Wallis y Futuna",
    "pt-BR": "Wallis e Futuna",
    "fr": "Wallis-et-Futuna",
    "de": "Wallis und Futuna",
    "zh-Hans": "瓦利斯和富图纳",
    "hi": "वालिस और फ़्यूचूना",
    "ja": "ウォリス・フツナ",
    "ru": "Уоллис и Футуна",
    "id": "Kepulauan Wallis dan Futuna",
    "bn": "ওয়ালিস ও ফুটুনা"
  },
  "WS": {
    "en": "Samoa",
    "tr": "Samoa",
    "es": "Samoa",
    "pt-BR": "Samoa",
    "fr": "Samoa",
    "de": "Samoa",
    "zh-Hans": "萨摩亚",
    "hi": "समोआ",
    "ja": "サモア",
    "ru": "Самоа",
    "id": "Samoa",
    "bn": "সামোয়া"
  },
  "XA": {
    "en": "Pseudo-Accents",
    "tr": "Psödo Aksanlar",
    "es": "Pseudoacentos",
    "pt-BR": "Pseudossotaques",
    "fr": "pseudo-accents",
    "de": "Pseudo-Akzente",
    "zh-Hans": "伪地区",
    "hi": "सूडो-एक्सेंट",
    "ja": "疑似アクセント",
    "ru": "псевдоакценты",
    "id": "Aksen Asing",
    "bn": "সিউডো-অ্যাকসেন্ট"
  },
  "XB": {
    "en": "Pseudo-Bidi",
    "tr": "Psödo Bidi",
    "es": "Pseudobidi",
    "pt-BR": "Pseudobidirecional",
    "fr": "pseudo-bidi",
    "de": "Pseudo-Bidi",
    "zh-Hans": "伪双向语言地区",
    "hi": "सूडो-बायडायरेक्शनल",
    "ja": "疑似 BIDI",
    "ru": "псевдо-Bidi",
    "id": "Pseudo-Bidi",
    "bn": "সিউডো-বিডি"
  },
  "XK": {
    "en": "Kosovo",
    "tr": "Kosova",
    "es": "Kosovo",
    "pt-BR": "Kosovo",
    "fr": "Kosovo",
    "de": "Kosovo",
    "zh-Hans": "科索沃",
    "hi": "कोसोवो",
    "ja": "コソボ",
    "ru": "Косово",
    "id": "Kosovo",
    "bn": "কসোভো"
  },
  "YD": {
    "en": "Yemen",
    "tr": "Yemen",
    "es": "Yemen",
    "pt-BR": "Iêmen",
    "fr": "Yémen",
    "de": "Jemen",
    "zh-Hans": "也门",
    "hi": "यमन",
    "ja": "イエメン",
    "ru": "Йемен",
    "id": "Yaman",
    "bn": "ইয়েমেন"
  },
  "YE": {
    "en": "Yemen",
    "tr": "Yemen",
    "es": "Yemen",
    "pt-BR": "Iêmen",
    "fr": "Yémen",
    "de": "Jemen",
    "zh-Hans": "也门",
    "hi": "यमन",
    "ja": "イエメン",
    "ru": "Йемен",
    "id": "Yaman",
    "bn": "ইয়েমেন"
  },
  "YT": {
    "en": "Mayotte",
    "tr": "Mayotte",
    "es": "Mayotte",
    "pt-BR": "Mayotte",
    "fr": "Mayotte",
    "de": "Mayotte",
    "zh-Hans": "马约特",
    "hi": "मायोते",
    "ja": "マヨット",
    "ru": "Майотта",
    "id": "Mayotte",
    "bn": "মায়োত্তে"
  },
  "YU": {
    "en": "Serbia",
    "tr": "Sırbistan",
    "es": "Serbia",
    "pt-BR": "Sérvia",
    "fr": "Serbie",
    "de": "Serbien",
    "zh-Hans": "塞尔维亚",
    "hi": "सर्बिया",
    "ja": "セルビア",
    "ru": "Сербия",
    "id": "Serbia",
    "bn": "সার্বিয়া"
  },
  "ZA": {
    "en": "South Africa",
    "tr": "Güney Afrika",
    "es": "Sudáfrica",
    "pt-BR": "África do Sul",
    "fr": "Afrique du Sud",
    "de": "Südafrika",
    "zh-Hans": "南非",
    "hi": "दक्षिण अफ़्रीका",
    "ja": "南アフリカ",
    "ru": "Южно-Африканская Республика",
    "id": "Afrika Selatan",
    "bn": "দক্ষিণ আফ্রিকা"
  },
  "ZM": {
    "en": "Zambia",
    "tr": "Zambiya",
    "es": "Zambia",
    "pt-BR": "Zâmbia",
    "fr": "Zambie",
    "de": "Sambia",
    "zh-Hans": "赞比亚",
    "hi": "ज़ाम्बिया",
    "ja": "ザンビア",
    "ru": "Замбия",
    "id": "Zambia",
    "bn": "জাম্বিয়া"
  },
  "ZR": {
    "en": "Congo - Kinshasa",
    "tr": "Kongo - Kinşasa",
    "es": "República Democrática del Congo",
    "pt-BR": "Congo - Kinshasa",
    "fr": "Congo-Kinshasa",
    "de": "Kongo-Kinshasa",
    "zh-Hans": "刚果（金）",
    "hi": "कांगो - किंशासा",
    "ja": "コンゴ民主共和国(キンシャサ)",
    "ru": "Конго - Киншаса",
    "id": "Kongo - Kinshasa",
    "bn": "কঙ্গো-কিনশাসা"
  },
  "ZW": {
    "en": "Zimbabwe",
    "tr": "Zimbabve",
    "es": "Zimbabue",
    "pt-BR": "Zimbábue",
    "fr": "Zimbabwe",
    "de": "Simbabwe",
    "zh-Hans": "津巴布韦",
    "hi": "ज़िम्बाब्वे",
    "ja": "ジンバブエ",
    "ru": "Зимбабве",
    "id": "Zimbabwe",
    "bn": "জিম্বাবোয়ে"
  },
  "ZZ": {
    "en": "Unknown Region",
    "tr": "Bilinmeyen Bölge",
    "es": "Región desconocida",
    "pt-BR": "Região desconhecida",
    "fr": "région inconnue",
    "de": "Unbekannte Region",
    "zh-Hans": "未知地区",
    "hi": "अज्ञात क्षेत्र",
    "ja": "不明な地域",
    "ru": "неизвестный регион",
    "id": "Wilayah Tidak Dikenal",
    "bn": "অজানা অঞ্চল"
  }
}
